import { Component, OnInit, PLATFORM_ID, Inject, OnDestroy, Input, effect, ViewChild, ElementRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { DecimalPipe, isPlatformBrowser } from '@angular/common';
import { ReportMapService } from '../../services/report-map.service';
import { SharedService } from '../../../common/services/shared.service';
import { GlobalContants } from '../../../common/constants/global.contants';
import { environment } from 'src/environments/environment';
import { ReportService } from '../../services/report.service';
import { wktToGeoJSON } from "@terraformer/wkt";
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, debounceTime, distinctUntilChanged, firstValueFrom, fromEvent, fromEventPattern, takeUntil, timer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ReportsViewEnum } from '../../models/enums/reports.enum';
import { SEOService } from 'src/app/common/services/SEOService.service';
import { GoogleAnalyticsService } from 'src/app/common/services/google-analytics.service';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { StoreService } from 'src/app/common/services/store.service';
import { MapLayersComponent } from './map-layers/map-layers.component';
import { CATEGORY_GROUP_NAMES, CATEGORY_GROUP_NAMES_LEGEND, layerConstant } from 'src/app/common/constants/layer-constant';
import { UserService } from 'src/app/common/services/user.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// 
import Map from 'ol/Map';
import View from 'ol/View';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT';
import { fromLonLat, transform } from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import Icon from 'ol/style/Icon';
import Text from 'ol/style/Text';
import { Draw } from 'ol/interaction';
import { toLonLat } from "ol/proj";
import Layer from 'ol/layer/Layer';
import MapBrowserEvent from 'ol/MapBrowserEvent';
import { FeatureLike } from 'ol/Feature';
import { Style, Stroke, Fill, RegularShape } from 'ol/style';
import { defaults as defaultControls, Zoom } from 'ol/control';
import { Positioning } from 'ol/Overlay';
import LayerGroup from 'ol/layer/Group';
import TileWMS from 'ol/source/TileWMS';
import { Interaction } from 'ol/interaction';
import DragPan from 'ol/interaction/DragPan';
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom';
import DoubleClickZoom from 'ol/interaction/DoubleClickZoom';
import KeyboardPan from 'ol/interaction/KeyboardPan';
import KeyboardZoom from 'ol/interaction/KeyboardZoom';
import DragZoom from 'ol/interaction/DragZoom';   // Box Zoom equivalent
import PinchZoom from 'ol/interaction/PinchZoom'; // Tap/Pinch Zoom on touch
import Overlay from 'ol/Overlay';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { createBox } from 'ol/interaction/Draw';
import {boundingExtent} from 'ol/extent.js';
import Cluster from 'ol/source/Cluster.js';
import CircleStyle from 'ol/style/Circle.js';
import Geometry from 'ol/geom/Geometry';
import Polygon, { fromCircle } from 'ol/geom/Polygon';
import MultiPolygon from 'ol/geom/MultiPolygon';
import Circle from 'ol/geom/Circle';
import { unByKey } from 'ol/Observable';
import * as olExtent from 'ol/extent';
import { intersects as intersectsExtent } from "ol/extent";
import { getArea, getLength } from "ol/sphere";
import LineString from 'ol/geom/LineString';
import Translate from 'ol/interaction/Translate';
import Modify from 'ol/interaction/Modify';

export interface PopupDataInterface {
  type: string, propertiesdata: any, allowedAttributes: any, btn_label?: any, tenantData?: any, className?: string, columnName?: string
}

@Component({
  selector: 'app-reports-map-view',
  templateUrl: './reports-map-view.component.html',
  styleUrls: ['./reports-map-view.component.scss']
})
export class ReportsMapViewComponent implements OnInit, OnDestroy {
  @ViewChild('mapIdentifier') mapIdentifier!: ElementRef;
  private catchmentPolyGonDrawStart:boolean= false;
  mapZoomCurrentValue: number = 12;
  parcelStrokeColor:string=''
  property_details_pbf:any=null;
  mvtPbfLayerSource:any;
  projectTileFeatures: any[] = [];
  projectOverlays: Overlay[] = [];
  pbfVectorTileOverlays: any = {};
  parcelLoaderOverlays: any;
  private parcelRequestId = 0;
  private isDrawingCatchment:boolean = false;
  private catchmentTooltipOverlay!: Overlay;
  private catchmentTooltipEl!: HTMLDivElement;
  private viewport!: HTMLElement;
  hoveredProjectUid: string | null = null;
  property_land_zoning: any | null = null;
  property_land_zoning_activelayer: any | null = null;
  private cancelMapApiCH$ = new Subject<void>();
  private cancelMapApi$ = new Subject<void>();
  hoverOverlay!: Overlay;
  hoveredFeature: Feature | null = null;
  streetLayer: any = null;
  amenityStreetMoveKey: any = null;
  propertyLandZoningSource:boolean = true;
  parcel_layer_Active:boolean=false;
  translateInteraction!: Translate;
  modify: any;
  private mapModifySubject = new Subject<void>();


  mapWidth!: number;
  mapHeight!: number;
  maxZoomLimit:number = 20;
  circleAnenities: any = [];
  // public mapCenter: any = [29.3560456, 47.9999959];
  public mapCenter: any = [24.713679050668613, 46.67510821294586];// Riyadh
  public base_Layer: any;
  public satelliteLayer: any;
  public map: any;
  private firstRun:boolean = true;
  public layerData: any;
  public estaterMapLayer: any;
  public projectLayer_pbf: any;
  public seenProperties:string[] = [];
  public parcelLayerWms: any;
  public parcelLayerPbf: any;
  public Orig_parcelLayerWms: any;
  public pbfParcelLayer: any;
  public layerselected: number = 1;
  public fillOpacityLegend: number = 1;
  public legend_data: any = [];
  public legendToggle: boolean = false;
  public customFIlter: boolean = false;
  public propertyinfoToggle: boolean = false;
  public is_avg_transaction: boolean = false;
  public is_transaction_table: boolean = false;
  public is_rental_table: boolean = false;
  public selected_property: any;
  public propertyUid: string = '';
  public selected_downloadopt: string = 'print';
  public downloadopt_toggle: boolean = false;
  public report_countLayer: any;
  public streetNameLayer: any;
  public tenant_countLayer: any;
  public tenantMarkers: any;
  public individualTenantMarkers: any;
  public amenitiesMarkers: any;
  public map_spinner: boolean = false;
  public transaction_layer_active: boolean = true;
  public transaction_Popup: any;
  public current_lang: any = 'en';
  public cql_param: string = ``;
  public editableLayers: any;
  public wmsCityLayer: any;
  public drawControl: any;
  public polygon_create: boolean = false;
  public popup_remove: any = ['lat', 'lon', 'wkt', 'property_name', 'property_uid'];
  public mainTransaction_Lyrdata: any;
  public transaction_Lyrdata: any;
  public mapZoom: any = 12;
  public drawPolySub$: Subscription = new Subscription();
  public overlay_LayerSub$: Subscription = new Subscription();
  public overlay_LayerSub2$: Subscription = new Subscription();
  public count_LayerSub$: Subscription = new Subscription();
  public mapCoordinatesSub$: Subscription = new Subscription();
  public amenitiesItemListSub$: Subscription = new Subscription();
  public streetNameListSub$: Subscription = new Subscription();
  public selectedReportSub$: Subscription = new Subscription();
  public resetFilterSub$: Subscription = new Subscription();
  public legendLayerSub$: Subscription = new Subscription();
  public moveEndSubscription1$: Subscription = new Subscription();
  public moveEndSubscription2$: Subscription = new Subscription();
  public moveEndSubscription3$: Subscription = new Subscription();
  public moveEndSubscription4$: Subscription = new Subscription();
  public moveEndSubscriptionMap$: Subscription = new Subscription();
  public polygon_WKT: any;
  public overlay_Layer: any;
  public overlay_Layer_category_zoning: any;
  public overlay_Layer_category_category: any;
  public projectLayer: any;
  public circleLayer: any;
  public Pbf_OverlayLayer: any = {};
  public drawnPolygons: any = [];
  public mapLayers: any[] = [];
  public catchment_Markers: any;
  public filterObj: any;
  public showProjectToggle: boolean = false;
  public isClusterActive: boolean = true;
  public resizeObserver: any;
  public legend_data_by_group: any;
  public legendDataGroupBy: any;
  public current_lang_id: number = 1;
  public currentReportData: any = null;
  public currentReportDataLegends: string[] = [];
  public polygon_chip: boolean = false;
  public reportName: string = '';
  catchmentData: any[] = [];
  public layer_year = new Date().getFullYear();
  routeSub$: Subscription = new Subscription();
  public draw_btn_toggle: boolean = false;
  private unsubscribe$: Subject<void> = new Subject<void>();
  @Input() classname!: string;
  @Input() tenantPropertyInfo: any;
  @Input() filterList: any;
  @Input() is_save_allow !: boolean;
  @Input() studyName: string = '';
  isReport !: boolean;
   mapLayer:string = 'default';
  overlay_mapLayer_current = this.mapService.overlay_mapLayer_current
  public pbfStyle_filter = {
    weight: 2,
    color: 'black',
    dashArray: '2, 6',
    fillOpacity: 0
  };
  public pbfStyle_nonfilter = {
    weight: 0,
    fillColor: '#F96038',
    color: '#F96038',
    fillOpacity: 0,
    fill: true,
  };
  public showAreaToggle: boolean = false;
  public isTenant: boolean = false;
  NeighDetails$: Subscription = new Subscription();
  neightInfo: any;
  projecttInfovar: any;
  lastMarker: any;
  currentLegendView$: Subscription | null = null;
  currentReportView$: Subscription = new Subscription();
  private lastClusterValue: any = null;
  overlayMapLayerSubscription$: Subscription | null = null;
  selectedReportSubscription$: Subscription = new Subscription();
  currentReportView!: number;
  viewType = ReportsViewEnum;
  markerObjects: any[] = [];
  showMultiLatLon: any[] = [];
  TenantName: any = '';//this.mapService.tenantName();
  reportId: any;
  layerEndPoint = layerConstant.parcel;
  layer1: any;
  layer2: any;
  layer3: any;
  layer4: any;
  pbfLayer1: any;
  pbfLayer2: any;
  pbfLayer3: any;
  pbfLayer4: any;
  adjustedLatLng: unknown;
  adjustedLatLngUniversal: unknown;
  adjustedZoom: number = 16;
  polys: any;
  featureGroup: any;
  poly: any;
  isCatchmentExpand: boolean = false;
  PBIpropertyToggle: boolean = false;
  parcelLayerActive: boolean = false;

  zoomControlPosition: string = 'bottomright';   // store the position on zoom Control on map.
  zoomControl: any;        // store the zoom control which is being added on map.
  loadCatchmentShow: boolean = false;
  reLoadCatchmentShow: boolean = false;
  amenitiesPopups: any = [];
  selectedMaplayer:any;
  //Layers OL
  vectorLayerURL: any;
  rasterLayerURL: string='';
  rasterLayerURLAll: string='';
  vectorLayerToken: string | null = null;
  parcelsLayerOL:any;
  mvtPbfLayerOL: any;
  @ViewChild('customLayerOverlay') customLayerOverlay!: MapLayersComponent;
  private layerControlContainer!: HTMLElement;
  public layerControl: any;
  public layerGroup: any;
  public baseLayers: any;
  public mapLayertoggle: boolean = false;
  public streetBounds: any;


  // Universal Map search variables
  searchedData: any      // store property data bases on search text
  // recentSearchedData: any  // store recent searched property data.
  // showRecentSearch: boolean = true; // To show recentSearched data conditionaly
  mapMarker: any;      // Store the leaflet marker of selected property
  isOpenMapSearch: boolean = false; // used to open search bar for property search .
  universalSearchPopUp: any     // Store the leaflet popup of selected property
  // universalSearchPropertyName: string = ''    // selected searched property name/uid
  // universalSearchPropertyDetail: string = '';   // selected searched property name along which neigh and block name
  isShowChip: boolean = false;     // To show or hide the chip (contains selected property name/uid)
  savedCatchment: any = [];
  cityCode: any = '';
  searchOverlayDiv: any;
  customLayerController: any;
  private mouseEnterHandler!: () => void;
  private mouseEnterHandlerRemove!: () => void;
  private mouseLeaveHandler!: () => void;
  
  mapPopupInstance: any;
  mapPopupInstanceProperty: any;
  popupContentProperty!: PopupDataInterface;
  popupContent!: PopupDataInterface;
  popupContentuniversal!: PopupDataInterface;
  Searched_properties: any;
  clusterInfoList: any = []
  divTocontrolEventOnMap: any;
  yearFilterObserver$ = new Subject<string | number>();
  selectedLegends:any = null;
  isLumSum:any = {isLumsum:false};
  clustercount:number = 0;
  
  popupOverlay!: Overlay;

  drawCatchmentControl =false;

  geojson = new GeoJSON();
  
  drawSource = new VectorSource();
  drawLayer!: VectorLayer<VectorSource>;
  MAX_SHAPES = 4;

  colors:string[] = ['#FF6C16', '#3774E8', '#28B044', '#6D47E1'];
  colorsClass: string[] = ['darw-chipone', 'darw-chiptwo', 'darw-chipthree', 'darw-chipfour'];
  availableColors = [...this.colors];
  availableColorClasses = [...this.colorsClass];
  usedColors: { id: string, color: string,area:string, className: string , catchmentType: string}[] = [];
  private segmentStyles: Style[] = [];
  draw!: Draw | null;


  SelectedShap: string='';

  markerSource = new VectorSource();

  markerLayer = new VectorLayer({
    source: this.markerSource,
    zIndex: 20
  });
  universalSearchMarker: Feature<Point> | undefined;
  tenantClusterLayer: any;

  tenantMarkerSource = new VectorSource();
  // individualTenantSource = new VectorSource();

  tenantClusterSource = new Cluster({
      distance: 60,
      source: this.tenantMarkerSource
    });
  showOnMapPropData: any;
  streetNamePointerKey: any = null;


  amenitiesSource = new VectorSource();
  circleSource = new VectorSource();

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    const clickedElement = event.target as HTMLElement;
    // Check if the click is outside the active div
    const clickedInside = this.eRef.nativeElement.querySelector(`#map-search`)?.contains(clickedElement);
    if (!clickedInside && this.isOpenMapSearch) {
      this.isOpenMapSearch = false;
      if (this.Searched_properties) {
        this.isShowChip = true;
      }
      // this.showRecentSearch = true;
      this.removeScrollPropagationEvent();
    }
  }


private zoomListener: any;
private moveEndListener: any;

  constructor( private http: HttpClient, private eRef: ElementRef, @Inject(PLATFORM_ID) private platformId: Object, private sharedService: SharedService, private _decimalPipe: DecimalPipe,
    private mapService: ReportMapService, public reportService: ReportService, private dailog: MatDialog,
    private activatedRoute: ActivatedRoute, private router: Router, private translate: TranslateService,
    private _seoService: SEOService, private _googleAnalyticsService: GoogleAnalyticsService, private alertService: AlertService,
    private storeService: StoreService, private cdr: ChangeDetectorRef, private userService: UserService) {
    this.mapService.mapObject = this;
    
    this.sharedService.language$.pipe(
      debounceTime(200),
      takeUntil(this.unsubscribe$)
    ).subscribe((lang) => {
      
      this.current_lang_id = lang == 'ar' ? 2 : 1;
      this.current_lang = lang;
      
      if (this.mapPopupInstance && this.mapPopupInstance.isOpen()) {
        let content = this.mapService.popup_content(this.popupContent.type, this.popupContent.propertiesdata, this.popupContent.allowedAttributes, this.popupContent.btn_label, this.popupContent.tenantData, this.popupContent.className);
        this.mapPopupInstance.setContent(content)
      }
      if (this.mapPopupInstanceProperty && this.mapPopupInstanceProperty.isOpen()) {
        let content = this.mapService.popup_content(this.popupContentProperty.type, this.popupContentProperty.propertiesdata, this.popupContentProperty.allowedAttributes, this.popupContentProperty.btn_label, this.popupContentProperty.tenantData, this.popupContentProperty.className, this.popupContentProperty.columnName);
        this.mapPopupInstanceProperty.setContent(content)
      }
      if (this.universalSearchPopUp && this.universalSearchPopUp.isOpen()) {
        let content = this.mapService.popup_content(this.popupContentuniversal.type, this.popupContentuniversal.propertiesdata, this.popupContentuniversal.allowedAttributes, this.popupContentuniversal.btn_label, this.popupContentuniversal.tenantData, this.popupContentuniversal.className);
        this.universalSearchPopUp.setContent(content)
      }
    });
    this.selectedReportSubscription$?.unsubscribe();
    this.selectedReportSubscription$ = this.reportService.selectedReport$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((data) => {
      this.removeLayers(data);
      
      this.mapLayertoggle = false;
      if (this.activatedRoute.snapshot.queryParams['rid']) {
        this.draw_btn_toggle = true;
      }
      else this.draw_btn_toggle = false;
      if (data.flag && data.type == 'new_report') {
        this.reportService.selectedOfficeGraph = null;
        if (!this.activatedRoute.snapshot.queryParams['polygon']) this.resetCatchmentConfirm('clear');
        // this.isClusterActive = true;
        this.lastClusterValue = null;
       this.isLumSum = layerConstant.rentalClusters.find((item:any) => item.default === true);
        if(this.report_countLayer && this.map && this.hasLayer(this.report_countLayer)){
          // this.map?.removeLayer(this.report_countLayer);
          this.removeCustomMaker(true);
          this.report_countLayer = null;
        }
        // this.createSVGPattern('', '', '', 0, 0, true);
        if(this.map && this.map?.getView().getZoom() > 14){ this.map?.getView().setZoom(12); }
        this.sharedService.setStoreValue(GlobalContants.StoreKey.legend, null);
        this.sharedService.setStoreValue(GlobalContants.StoreKey.zoning, null);
        this.is_avg_transaction = false;
        this.currentReportData = this.reportService.getCurrentReport();
        this.currentReportDataLegends =  [...this.currentReportData.legend];
        let zoningLayerData:any = this.currentReportDataLegends.find((i: any) => i.legend_type === layerConstant.zoning);
        this.property_land_zoning = zoningLayerData;
        this.propertyLandZoningSource = zoningLayerData?.isGeoServerSource ?? true;
        if(this.overlay_Layer_category_zoning)this.map?.removeLayer(this.overlay_Layer_category_zoning);
        setTimeout(()=>{
          this.overlay_Layer_category_zoning = null;
           this.addWmsZoningCategoryLayers(this.currentReportDataLegends);
          this.legendMapLayer([], this.currentReportData.legend)
        }, 1000);
        this.is_transaction_table = (this.currentReportData?.filter_table == layerConstant.transaction_summary)? true:false;
        this.is_rental_table = (layerConstant.rentalComponentList.includes(this.currentReportData?.query?.component[0]))? true:false;
        // 
        const valuesToCheck = [
          this.currentReportData?.query?.component?.[0],
          this.currentReportData?.cluster_view
        ].filter(Boolean);

        this.is_rental_table = valuesToCheck.some(v =>
          layerConstant.rentalComponentList.includes(v)
        );
        // subscription filter check
        this.clustercount = this.is_rental_table?1:0;
        let subsreport = this.reportService.userSubscription.find((type: any) => this.currentReportData.id == type.report_id)
        if (subsreport?.filter) {
          this.currentReportData.filter?.map((e: any) => {
            const matchingUserFilter = subsreport.filter?.find((userFilter: any) => userFilter.parameter_name === e.parameter_name);
            if (matchingUserFilter) {
              if (matchingUserFilter?.default) {
                e['default'] = matchingUserFilter?.default;
              }
              e['dynamic_value'] = matchingUserFilter?.dynamic_value;
              e['required'] = matchingUserFilter?.required;
              e['map_filter'] = matchingUserFilter?.map_filter;
              e['type'] = matchingUserFilter?.type;
            }
          })
        }
        if (this.currentReportData) {
          this.seoMetupdates(this.currentReportData.label[1], 'reports');
          this.layerData = this.currentReportData.layer;
          if (!this.legend_data_by_group) this.legend_data_by_group = this.currentReportData.legend;
          this.mapLayers = this.currentReportData.map_layer;
          let activeLayer = this.mapLayers.filter((item:any)=> item.display)
          this.property_details_pbf = activeLayer.find(
            (item: any) => item.layer_name === this.layerEndPoint
          );
          if(activeLayer?.length) {
            timer(1000).subscribe(() => this.overlayLayers(activeLayer));
          }
          
        }
        this.reportName = this.reportService?.selectedRepored?.report_name;
        this.filterObj = this.currentReportData.filter //// Dynamic Filter impleentation from MI APplication
      }
    })

    this.mapService.propertyinfotoggle.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((toggle: boolean) => {
      if (toggle) {
        this.propertyinfoToggle = true;
        this.reportService.projectReportView = true;
      } else {
        this.propertyinfoToggle = false;
      }
    })
    this.mapService.resetMarker.subscribe((flag: any) => {
      if (flag) {
        if (this.map) this.closePopup();
        this.removeCustomMaker(true);
      }
    })
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.reportId = params['rid'];
      this.propertyinfoToggle = false;
      this.showProjectToggle = false;
      this.showAreaToggle = false;
      if (this.drawControl) this.drawControl.remove();
      // this.removeCustomMaker(true, true);
      this.mapPopupInstance = null;
      this.mapService.resetMarker.next(true);
      let year = params['year'] ? params['year'] : null;
      this.yearFilterObserver$.next(year);
    });

    this.mapService.selected_propertydetails.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((data: any) => {
      if (data) this.propertyInfo(data);
    })
    effect(() => this.TenantName = this.mapService.tenantName());
   effect(() => {
    // return;
      const cluster = this.mapService.islumsumCluster$(); 
      if (!cluster) return;
      // Skip if same as before
      if (this.lastClusterValue === cluster.value) return;
      this.lastClusterValue = cluster.value;
      this.isLumSum = cluster; 
      this.createTransactionLegend(true, this.isLumSum);
      if(!this.firstRun){
        if(this.map){ this.removeReportLayerSafe(this.report_countLayer, this); this.report_countLayer = null; }
        if (cluster.value != layerConstant.rentalClusters[0].value) this.addMaplayer(true);
        this.legendCount();
      }
      this.firstRun = false;
    }, { allowSignalWrites: true });

  }
  seoMetupdates(title: string = '', type: string = '') {
    let obj_label: string = this.reportService.selectedObjective?.obj_label?.[1] ? this.reportService.selectedObjective.obj_label[1] : '';
    let study_label: string = this.reportService.selectedStudies?.study_label?.[1] ? this.reportService.selectedStudies.study_label[1] : '';
    let reportTree = `${obj_label ? obj_label + ' > ' : ''} ${study_label ? study_label + ' > ' : ''} ${title}`;
    if (obj_label) this._googleAnalyticsService.trackEvent('button_click', { event_category: 'Generate Report', event_name: 'Button Click', event_label: 'Create Report', event_value: reportTree, screen_name: '' })
    this._seoService.updateTitle(`${GlobalContants.defaultTitleConstant.defaultTitle} | ${title}`)
  }


  ngOnInit(): void {
    this.mapService.toggleCluster$.pipe(
      distinctUntilChanged(),
      takeUntil(this.unsubscribe$)
    ).subscribe((item: any) => {
      // return;
      this.isClusterActive = item.flag;
      if(!item.flag) {
        // if (this.map?.hasLayer(this.report_countLayer)) this.map?.removeLayer(this.report_countLayer);
        if (this.map?.getLayers().getArray().includes(this.report_countLayer)) {
            this.map?.removeLayer(this.report_countLayer);
          }
      } else {
        if ((this.map?.getView().getZoom() < 16) && this.report_countLayer && !this.map?.getLayers().getArray().includes(this.report_countLayer)) this.map?.addLayer(this.report_countLayer);
      }
      if (this.activatedRoute.snapshot.queryParams['rid'] && item.flag) {
        const lege = GlobalContants.StoreKey.legend;
        let legend = this.sharedService.getStoreValue(lege);
        // 
      this.multiBbox(this.bboxString(), legend);
      } else {
        const that = this;
            [that.layer1, that.layer2, that.layer3, that.layer4].forEach((layer: any, index:any) => {
              this.removeSnLayer(index + 1);
            })
      }
    })
    this.yearFilterObserver$.pipe(
      distinctUntilChanged(),
      takeUntil(this.unsubscribe$)
    ).subscribe((year: any) => {
      // if (year) {
        let parcelLayer = this.selectedMaplayer?.find((layer: any) => layer.layer_name == layerConstant.parcel && layer.display) || this.mapLayers?.find((layer: any) => layer.layer_name == layerConstant.parcel && layer.display);
        let legends = (this.selectedLegends) ? this.selectedLegends : this.currentReportDataLegends
        if(legends){
          if(this.overlay_Layer_category_zoning)this.map?.removeLayer(this.overlay_Layer_category_zoning);
          this.overlay_Layer_category_zoning=null;
          this.addWmsZoningCategoryLayers(legends)
        }
        //--if(parcelLayer) this.addParcelPbfLayer(parcelLayer)
        if(parcelLayer && !legends){
          this.addParcelLayerMVT(parcelLayer)
        }
      // }
    })
    this.getCurrentCity();
    this.mapService.universalSearchtoggle.subscribe(res => {
      if (!res) {
        this.isOpenMapSearch = false;
        this.closeChip(true)
      }
    })
    if (isPlatformBrowser(this.platformId)) {
      if (this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceId)) {
        this.mapCenter = [this.sharedService.getStoreValue(GlobalContants.StoreKey.latitude), this.sharedService.getStoreValue(GlobalContants.StoreKey.longitude)];
      }
      // this.initMap();
    }
    
    this.NeighDetails$ = this.reportService.transactionPropertyDetails.subscribe((data) => {
      if (data) {
        // Check for neigh_uid
        if (data && data.neigh_uid) {
          this.showAreaToggle = true;
          this.neightInfo = data;
          this.showProjectToggle = false;
          this.projecttInfovar = {}
          // reset property
          this.selected_property = {};
          this.propertyinfoToggle = false;
          this.reportService.projectReportView = true;
        }
        // Check for proj_uid
        if (data && data.proj_uid) {
          this.showProjectToggle = true;
          this.reportService.isProjectDetailOpen.set(true);
          this.reportService.projectReportView = true;
          this.projecttInfovar = data;
          this.showAreaToggle = false;
          this.neightInfo = {};
          // reset property
          this.selected_property = {};
          this.propertyinfoToggle = false;
        }
        if (data && !data.proj_uid && this.showProjectToggle)
          this.showProjectToggle = false;
      } else {
        //reset all
        this.projecttInfovar = {};
        this.showProjectToggle = false;
        this.neightInfo = {};
        this.showAreaToggle = false;
        // reset property
        this.selected_property = {};
        this.propertyinfoToggle = false;

        // reset tenant floor layout
        this.reportService.showTenantMap$.next(false);
        this.reportService.detailPageState$.next(false);
        this.tenantPropertyInfo = null;

        // back to report from property
        this.reportService.projectReportView = false;
        this.reportService.reportView$.next(ReportsViewEnum.mapGridView)
      }
    });

    this.currentReportView$ = this.reportService.reportView$.subscribe((view: number) => {
      if (this.currentReportView != view) {
        this.currentReportView = view;
      }
    });
    this.reportService.loadCatchementDataapi$.subscribe((data: boolean) => {
      this.getSavedCatchment()
    })

  }
  recenterMap() {
    if (!this.isTenant && this.showOnMapPropData) {
      const coordinates_data = this.showOnMapPropData;
      const properties = coordinates_data?.data;
      const btn_label = (coordinates_data?.layer_name == "project") ? 'Project' : '';
      const content = this.mapService.popup_content(coordinates_data?.layer_name, properties, this.currentReportData?.allowed_attributes, btn_label, '', '', coordinates_data.columnName);

      this.panToOLMap(properties.lat, properties.lon, 18)
      setTimeout(() => {
        this.OpenCustomPop(content, fromLonLat([properties.lon, properties.lat]), 'topCenter')
      }, 501);
    }
  }
  
  removeCustomMaker(flag: boolean = false, flag2: boolean = false) {
    let that = this;
    if (that.lastMarker) {
      that.map?.removeLayer(that.lastMarker);
      that.lastMarker = null;
      this.markerObjects.forEach(marker => {
        that.map?.removeLayer(marker);
      });
      that.markerObjects = [];
    }
    if (flag) {
      this.closePopup();
      if(this.mapMarker){
        this.removeOLMarker(this.mapMarker);
      }
      this.showOnMapPropData=null;
      if (this.divTocontrolEventOnMap)
        this.mapPanStopCondition('.tenentContaine', true);
      if (this.tenantMarkerSource) {
        this.tenantMarkerSource.clear()
      }
      this.TenantName = '';
      let time = new Date().getTime();
      this.mapService.selectedIndex.set(time.toString())
      that.showMultiLatLon = [];
      that.lastMarker = '';
      that.closePopup();
    }
    return that;
  }

  getCurrentCity() {
    // return;
    this.cityCode = this.storeService.get(GlobalContants.StoreKey.placeCode);
    this.sharedService.selectedCity$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((city: any) => {
      this.cityCode = this.storeService.get(GlobalContants.StoreKey.placeCode);
      this.reportService.showTenantMap$.next(false);
      this.reportService.detailPageState$.next(false);
      this.mapCenter = [this.sharedService.getStoreValue(GlobalContants.StoreKey.latitude), this.sharedService.getStoreValue(GlobalContants.StoreKey.longitude)];
     if (this.map) {
        const center = fromLonLat([this.mapCenter[1], this.mapCenter[0]]);
        this.map?.getView().setCenter(center);
        this.map?.getView().setZoom(this.mapZoom);
      }
      let data = {type: 'new_report'}
      this.removeLayers(data);
      this.closePopup();
      if (this.map) {
        if (this.hasLayer(this.wmsCityLayer)) {
          this.map?.removeLayer(this.wmsCityLayer);
          this.wmsCityLayer = ''
          if(this.overlay_Layer_category_category && this.hasLayer(this.overlay_Layer_category_category)){
            this.map?.removeLayer(this.overlay_Layer_category_category);
            this.overlay_Layer_category_category = '';
          }
          if(this.overlay_Layer_category_zoning && this.hasLayer(this.overlay_Layer_category_zoning)){
            this.map?.removeLayer(this.overlay_Layer_category_zoning);
            this.overlay_Layer_category_zoning = '';
          }
        }
        this.mvtTileLayerLogic();
        if (this.mapMarker)
          this.removeOLMarker(this.mapMarker);
      }
    });
  }
updateZoomButtons = () => {
  const zoomInButton = document.querySelector('.ol-custom-zoom-in') as HTMLButtonElement | null;
  const zoomOutButton = document.querySelector('.ol-custom-zoom-out') as HTMLButtonElement | null;

  if (!zoomInButton || !zoomOutButton) return; // avoid error

  const view = this.map?.getView();
  const zoom = view.getZoom()!;
  const minZoom = view.getMinZoom()!;
  const maxZoom = view.getMaxZoom()!;
  this.mapZoomCurrentValue = zoom;
      

  zoomInButton.disabled = zoom >= maxZoom;
  zoomOutButton.disabled = zoom <= minZoom;

  this.mapZoom = Math.round(zoom);
  this.mapService.setZoom(this.mapZoom);

  const center = view.getCenter(); 
  
  if (center) {
    const [lon, lat] = toLonLat(center); // [lon, lat]
    this.mapCenter = [lat, lon];
    this.mapService.setCentroid(`${lat}-${lon}`);
  }
};

/**
 * catchment and polygon style function
 * @param feature 
 * @returns 
 */
private measureStyleFunction(feature: any): Style[] {
  const resolution = this.map?.getView().getResolution() || 1;
  const styles: Style[] = [];
  const LTR = '\u200E';
  let geometry = feature.getGeometry();
  const type = geometry.getType();
  const color = feature.get('color') || '#3774E8';
  const polygonType = feature.get('catchmentType');
 // ---- Base Style ----
  styles.push(
    new Style({
      stroke: new Stroke({
        color: color,
        width: 3
      }),
      fill: new Fill({
        color: 'rgba(0,0,0,0)'
      })
    })
  );

  let label: string | undefined;
  let labelPoint: Point | undefined;
  let segmentLine: LineString | undefined;
  let showLabel = true;
    if (polygonType === 'Circle') {
      const circle = geometry as Circle;
      const center = (type == 'Circle')? circle.getCenter() :null;
      label = feature.get('area'); 
    if(center){
      labelPoint = new Point(center);
      const radius = geometry.getRadius();
      const pixelRadius = radius / resolution;
      label = radius > 1000 ? Math.round((radius / 1000) * 100) / 100 + ' km' : Math.round(radius * 10) / 10 + ' m';
      if (pixelRadius < 60) showLabel = false;
    } else {
      const area = geometry.getArea();
      const pixelArea = area / (resolution * resolution);
      if (pixelArea < 1000) showLabel = false;
      labelPoint = geometry.getInteriorPoint();
    }
      segmentLine = undefined;
    }
  else if ((polygonType === 'Rectangle' && type === 'Polygon') || (polygonType === 'Polygon' && type === 'Polygon')) {
    label = feature.get('area'); 
    labelPoint = geometry.getInteriorPoint();
    segmentLine = new LineString(geometry.getCoordinates()[0]);
    showLabel = false;
  } 
  if (segmentLine) {
    let count = 0;
    if(polygonType === 'Polygon') {
    let segmentStyle = new Style({
            text: new Text({
              font: '9px Manrope, Arial',
              fill: new Fill({ color: '#fff' }),
              textAlign: 'center',
              textBaseline: 'middle',
              backgroundFill: new Fill({ color: 'rgba(0,0,0,0.5)' }),
              padding: [2, 4, 2, 4],
              overflow: false
            })
          });
      segmentLine.forEachSegment((a, b) => {
        const segment = new LineString([a, b]);
        const label = this.formatLength(segment);
        if (this.segmentStyles.length - 1 < count) {
          this.segmentStyles.push(segmentStyle.clone());
        }
        const segmentPoint = new Point(segment.getCoordinateAt(0.5));
        this.segmentStyles[count].setGeometry(segmentPoint);
        this.segmentStyles[count]?.getText()?.setText(LTR+label);
        styles.push(this.segmentStyles[count]);
        count++;
      });
    } else {
      segmentLine.forEachSegment((a, b) => {

        const segment = new LineString([a, b]);
        const segmentLength = getLength(segment);
        const pixelLength = segmentLength / resolution;
        if (pixelLength < 40) return; 
        const text = segmentLength > 1000
          ? Math.round((segmentLength / 1000) * 100) / 100 + ' km'
          : Math.round(segmentLength * 10) / 10 + ' m';

        if (!this.segmentStyles[count]) {
          this.segmentStyles[count] = new Style({
            text: new Text({
              font: '9px Manrope, Arial',
              fill: new Fill({ color: '#fff' }),
              textAlign: 'center',
              textBaseline: 'middle',
              backgroundFill: new Fill({ color: 'rgba(0,0,0,0.5)' }),
              padding: [2, 4, 2, 4],
              overflow: false
            })
          });
        }
        const midPoint = new Point(segment.getCoordinateAt(0.5));
        this.segmentStyles[count].setGeometry(midPoint);
        this.segmentStyles[count].getText()?.setText(LTR + text);

        styles.push(this.segmentStyles[count]);
        count++;
      });
    }
  }

  if (label && labelPoint && showLabel) {

    const totalStyle = new Style({
      text: new Text({
        text: LTR + label,
        font: 'bold 10px Manrope, Arial',
        textAlign: 'center',
        textBaseline: 'middle',
        fill: new Fill({ color }),
        stroke: new Stroke({
          color: '#ffffff',
          width: 3
        }),
        backgroundFill: new Fill({
          color: 'rgba(255,255,255,0.85)'
        }),
        padding: [2, 4, 0, 4],
        overflow: false
      })
    });

    totalStyle.setGeometry(labelPoint);
    styles.push(totalStyle);
  }
  return styles;
}


/**
 * Initialize the OpenLayers map
 */
  private async initMap() {
    let that = this;
    this.satelliteLayer = new TileLayer({
      visible: false,
      source: new XYZ({
          url:'https://mt{0-3}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
          maxZoom: this.maxZoomLimit,
          minZoom: 4
        }),
        zIndex: 2
      })
    this.base_Layer = new TileLayer({
      visible: true,
      source: new XYZ({
        url: environment.cartoBasemapUrl,
        attributions: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: this.maxZoomLimit,
        minZoom: 4
      }),
      zIndex: 1
    });

    this.drawLayer = new VectorLayer({
      source: this.drawSource,
      zIndex: 17,
      declutter: true,
      style: (feature) => this.measureStyleFunction(feature)
    });
    
    that.map = new Map({
      target: 'map',
      layers: [that.base_Layer, this.satelliteLayer, that.drawLayer, that.markerLayer],
      view: new View({
        center: fromLonLat([that.mapCenter[1], that.mapCenter[0]]), // [lng, lat]
        zoom: that.mapZoom,
        minZoom: 6,
        maxZoom: that.maxZoomLimit,
        constrainResolution: true,   
        smoothResolutionConstraint: false
      }),
      // controls: [] // Remove zoom and other default controls
      controls: defaultControls({
        attribution: false,
        rotate: false,
        zoom: false // disable default zoom
      }).extend([
        new Zoom({
          className: 'ol-custom-zoom'
        })         
      ])
    });
    that.mapService.mapInstance = that.map;
    // === Enable drag for all features inside drawLayer
    // this.translateInteraction = new Translate({
    //   layers: [this.drawLayer]
    // });
    // that.map.addInteraction(this.translateInteraction);
    // this.translateInteraction.on('translateend', (event) => {
    //     this.mapModifySubject.next()
    //   });
    //=== Modify interaction for editing shapes
    this.modify = new Modify({source: this.drawSource});
    that.map.addInteraction(this.modify);
    this.modify.on('modifyend',(event: Event) => {
        this.mapModifySubject.next()
    });

    this.mapModifySubject.pipe(
      takeUntil(this.unsubscribe$),
      debounceTime(800)
    ).subscribe(() => {
      this.updateUrlPolygon();
    });
    // ------------------
    this.mvtTileLayerLogic();
    // Hover 
    let lastPointerTime = 0;
    let lastHoverFeature: Feature | null = null;
    that.viewport = that.map.getViewport();
    that.map?.on("pointermove", (evt: MapBrowserEvent) => {
      if (!that.map) return;
      
      if (this.isDrawingCatchment) {
        if (this.isDrawingCatchment || this.catchmentTooltipOverlay) {
          this.catchmentTooltipOverlay?.setPosition(evt.coordinate);
        }
        return;
      }
      const now = performance.now();
      if (now - lastPointerTime < 70) return; 
      lastPointerTime = now;
      const element = this.map?.getTargetElement();
      if ((element instanceof HTMLElement)) that.map.getTargetElement().style.cursor = "";
      that.viewport.classList.remove('cursor-pointer');
      const pixel = evt.pixel;
      if (this.mapZoomCurrentValue < 16) {
        const hitFeature = that.map?.forEachFeatureAtPixel(
          pixel,
          (feature: FeatureLike, layer: Layer) => {
            return (layer == that.report_countLayer) ? feature : null;
          }
        );
        if (hitFeature) {
          that.viewport.classList.add('cursor-pointer');
        }
        return; // stop here if we are only hovering clusters
      } 
      const chipFeature = this.map?.forEachFeatureAtPixel(
        evt.pixel,
        (feature: FeatureLike) => {
          return feature.get("isChip") ? feature : null;
        },
        { hitTolerance: 5 }
      );
      if(!chipFeature)return;
      that.viewport.classList.add('cursor-pointer');
      // that.map.getTargetElement().style.cursor = chipFeature ? "pointer" : "";

      let hovered: FeatureLike[] = [];
      try {
        hovered = that.map?.getFeaturesAtPixel(pixel) || [];
      } catch {
        return;
      }

      if (!hovered.length) {
        // if (lastHoverFeature?.setStyle) lastHoverFeature.setStyle(undefined);
        if (lastHoverFeature && lastHoverFeature.get("isChip")) {
            lastHoverFeature.setStyle(
              lastHoverFeature.get("baseStyle")
            );
            lastHoverFeature = null;
          }
        // lastHoverFeature = null;
        return;
      }

      // Pick the first real Feature instance
      const feature = hovered.find((f: FeatureLike) => f instanceof Feature) as Feature | undefined;
      if (!feature) return;
      if(feature.get('type') === 'marker') {
        // that.map.getTargetElement().style.cursor = "pointer";
        that.viewport.classList.add('cursor-pointer');
        return;
      }

      // Avoid re-applying style if hovering same feature
      if (lastHoverFeature === feature) return;
       const props_data = feature.get("customData") || {};
       
      if (lastHoverFeature && lastHoverFeature.get("isChip")) {
        lastHoverFeature.setStyle(
          lastHoverFeature.get("baseStyle")
        );
      }
      // that.map?.getTargetElement().style.cursor = "pointer";
     
      // Apply hover style safely
      try {
        if(feature.get("isChip")){
          feature.setStyle([
            new Style({
              stroke: new Stroke({ color: this.parcelStrokeColor, width: 1 }),
              fill: undefined,
              zIndex: 20,
            }),
            new Style({
              image: new Icon({
                src: that.createClusterIcon(
                  props_data.unit_rate,
                  props_data.property_rate,
                  props_data.unit_name,
                  props_data.width_unitname
                ),
                scale: 1.1,
              }),
              zIndex: 9999,
            })
        ]);
       }
      } catch {
        // Ignore style errors
      }

      lastHoverFeature = feature;
    });
    this.map?.on('moveend', this.updateZoomButtons);

    this.map?.getView().on('change:zoom', () => {
      const view = this.map?.getView();
      const mapZoom = view.getZoom();

      // store zoom
      this.mapService.setZoom(mapZoom);

      // call same function
      // this.baseLayerFunction(mapZoom);

      // remove marker when zoom < 15
      if (mapZoom < 15) {
        if (this.lastMarker) {
          this.map?.removeLayer(this.lastMarker);
        }
      }
     
    });

    this.mapFullScreen();

    if (this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceId)) {
      this.mapEvntSubscriber();
    }
    // this.addWmsCityBorderHighlight();

  }
  // MBTileList:string[] = [];
  async mvtTileLayerLogic() {
    this.cityCode = (this.cityCode || this.storeService.get(GlobalContants.StoreKey.placeCode) || '').toLowerCase();
    const _city_code = (this.cityCode  || 'ryd').toLowerCase();
    // const year = this.getMaxYear() || new Date().getFullYear();
    this.removeReportLayerSafe(this.wmsCityLayer, this);
    this.removeReportLayerSafe(this.parcelsLayerOL, this);
    await this.estaterMapLayerGet(_city_code);
    // Vector layer 
    this.mvtPbfLayerSource = new VectorTileSource({
      format: new MVT(),
      url: this.vectorLayerURL
    });
    const cityLayerStyle = new Style({
          stroke: new Stroke({ color: '#000000', width: 2}),
          fill: undefined,
          zIndex: 13 
    });
    let cityLayerOL = new VectorTileLayer({
      source: this.mvtPbfLayerSource,
      renderMode: 'vector',
      declutter: false,
      zIndex: 13,
      // properties: { layerName: "parcels" },
      style: (feature: FeatureLike) => {
        const props = feature.getProperties();
        if(props['layer'] == 'city'){
          return cityLayerStyle;
        }
        return undefined;
      }
    });

    this.map?.addLayer(cityLayerOL);
    this.wmsCityLayer = cityLayerOL;
  }
  /**
   * Fetches the Estater map layer for a specific city and year.
   * @param city_code 
   * @param year
   */
  async estaterMapLayerGet(city_code: string, year?: number) {
    // return;
  if (environment?.is_mapLayerEstater) {
    if (this.map && this.estaterMapLayer) this.removeReportLayerSafe(this.estaterMapLayer);
  }

  const headers = new HttpHeaders({
    Authorization: `Bearer ${environment.estaterMapTtoken}`,
  });

  try {
    const year = this.getMaxYear() || new Date().getFullYear();
    const estatertile: any = await firstValueFrom(
      this.http.get(`${environment.estaterMapUrl}/gettilesurl?city=${city_code}`, { headers })
    );

    if (!estatertile?.urls?.rasterUrl) {
      throw new Error("No rasterUrl found in response");
    }
    
    // ==get parcel  map layer yearwise  && use token from vectorUrl
    this.vectorLayerToken = new URL(estatertile.urls.vectorUrl).searchParams.get('token');
    this.vectorLayerURL = estatertile.urls.vectorUrl;
    this.rasterLayerURL = estatertile.urls.rasterUrl;
    this.rasterLayerURLAll = estatertile.urls.rasterUrlAll;
    // this.vectorLayerURL = `${environment.estaterMapUrl}/all/tiles/${city_code}/${year}/{z}/{x}/{y}?token=${this.vectorLayerToken}`;
    // ==end get parcel  map layer yearwise 

    // Create OL tile layer
    this.estaterMapLayer = new TileLayer({
      visible: true,
      source: new XYZ({
        url: estatertile.urls.rasterUrl,
        attributions: 'Powered by Estater',
        maxZoom: this.maxZoomLimit ?? 20,
        minZoom: 4,
      }),
      zIndex: 2
    });
// console.log('Estater map layer this.estaterMapLayer:', this.estaterMapLayer);
    if (environment?.is_mapLayerEstater && this.map) {
      this.map?.addLayer(this.estaterMapLayer);
    }

  } catch (err) {
    console.error("Something went wrong fetching Estater map layer:", err);
  }
}

removeSnLayer(sn: 1 | 2 | 3 | 4) {
  const map = this.map;
  const layers: Record<1 | 2 | 3 | 4, any>  = {
    1: this.layer1,
    2: this.layer2,
    3: this.layer3,
    4: this.layer4
  };
  if (layers[sn]) map.removeLayer(layers[sn]);
}

  /**
   * base layer add/remove functions
   * @param mapZoom
   */
  baseLayerFunction(mapZoom:number){
    // return;
    // if (mapZoom < 14) {
    //     if(environment?.is_mapLayerEstater && this.mapLayer == 'default') {
    //       // this.addReportLayerSafe(this.base_Layer, this);
    //       this.base_Layer.setVisible(true);
    //       this.satelliteLayer.setVisible(false);
    //     }
    //   } else {
    //     if(environment?.is_mapLayerEstater && this.mapLayer == 'default'){
    //       // this.removeReportLayerSafe(this.base_Layer, this);
    //       this.base_Layer.setVisible(false);
    //       this.satelliteLayer.setVisible(true);
    //     }
    //   }
  }
  setupMouseEvents(): void {
    // return;
    this.customLayerController = this.customLayerOverlay?.customLayerController.nativeElement;
    if (this.customLayerController) {
      this.customLayerController.addEventListener('wheel', this.preventScrollPropagation);

      let mouseEnter: unknown, mouseOut: unknown;
      mouseEnter = this.customLayerController.addEventListener('mouseenter', () => {
        this.disableMapInteractions();
        if (mouseOut) {
          this.customLayerController.removeEventListener('mouseleave', mouseOut);
        }
      });

      mouseOut = this.customLayerController.addEventListener('mouseleave', () => {
        this.enableMapInteractions();
        if (mouseEnter) {
          this.customLayerController.removeEventListener('mouseleave', mouseEnter);
        }
      });
    }
  }
  /**
   * Disable map interactions like drag, zoom, etc.
   */
  disableMapInteractions() {
  this.map?.getInteractions().forEach((interaction: Interaction) => {
    if (
      interaction instanceof DragPan ||             // dragging.disable()
      interaction instanceof MouseWheelZoom ||      // scrollWheelZoom.disable()
      interaction instanceof DoubleClickZoom ||     // doubleClickZoom.disable()
      interaction instanceof DragZoom ||            // boxZoom.disable()
      interaction instanceof KeyboardPan ||         // keyboard.disable()
      interaction instanceof KeyboardZoom ||        // keyboard.disable()
      interaction instanceof PinchZoom              // tap.disable()
    ) {
      interaction.setActive(false);
    }
  });
}
/**
 * Enable map interactions like drag, zoom, etc.
 */
enableMapInteractions() {
  this.map?.getInteractions().forEach((interaction: Interaction) => {
    interaction.setActive(true);
  });
}

  convertZoningColors(jsonData:any): string {
    if(!jsonData) return 'propertyName:zoning';
    const entries = Object.entries(jsonData);
    const result = [];
    result.push('propertyName:zoning');
    entries.forEach((item:any) => {
        const cleanColor = (item[1] ?? '')?.replace(/^#/, '');
      result.push(`fill_${item[0]}:${cleanColor}`);
    });
    return result.join(';');
}

addWmsZoningCategoryLayers(legend_data: any[] = []): void {
  const zoning = legend_data.find((i: any) => i.legend_type === layerConstant.zoning && i.display);
  const category = legend_data.find((i: any) => i.legend_type === layerConstant.category && i.display);
  let is_zoning_active = zoning?.display ?? false;
  this.property_land_zoning_activelayer = zoning;
  if(this.propertyLandZoningSource == false){
    this.addParcelLayerMVT(null, true, is_zoning_active);
  }
  const placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
  const place_id = this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceId);

  const overlay_url = `${environment.geoestater}wms-layer?place_id=${place_id}&token=${environment.user_token}&store=MI`;

  const year = this.getMaxYear();
  const city_code = (this.cityCode).toLowerCase();
  const cat_pattern_style = (city_code === 'kwt' || city_code === 'bhd') ? 'cat_pattern_kwt' : 'cat_pattern';

  if (!this.activatedRoute.snapshot.queryParams['rid']) return;

  if (!zoning && this.overlay_Layer_category_zoning) {
    this.map?.removeLayer(this.overlay_Layer_category_zoning);
    this.overlay_Layer_category_zoning = null;
  }
  if (!category && this.overlay_Layer_category_category) {
    this.map?.removeLayer(this.overlay_Layer_category_category);
    this.overlay_Layer_category_category = null;
  }

  // ZONING LAYER 
  if (zoning && !this.overlay_Layer_category_zoning && this.propertyLandZoningSource) {

    this.overlay_Layer_category_zoning = new TileLayer({
      source: new TileWMS({
        url: overlay_url,
        params: {
          LAYERS: `${placeCode}_${layerConstant.parcel}`,
          FORMAT: 'image/png',
          TRANSPARENT: true,
          VERSION: '1.1.0',
          STYLES: 'neigh_zone',
          CQL_FILTER: `year=${year}`
        },
        crossOrigin: 'anonymous',
        serverType: 'geoserver',
        hidpi: false 
      }),
      zIndex: 12,
      minZoom: 15,
      maxZoom: 22
    });

    this.map?.addLayer(this.overlay_Layer_category_zoning);

    this.overlay_Layer_category_zoning['filtername'] =
      `${placeCode}_${layerConstant.parcel}:year:=:${year}`;
  }

  //  CATEGORY LAYER (PATTERN)
  if (category && !this.overlay_Layer_category_category) {

    this.overlay_Layer_category_category = new TileLayer({
      source: new TileWMS({
        url: overlay_url,
        params: {
          LAYERS: `${placeCode}_${layerConstant.parcel}`,
          FORMAT: 'image/png',
          TRANSPARENT: true,
          VERSION: '1.1.0',
          STYLES: cat_pattern_style,
          CQL_FILTER: `year=${year}`
        },
        crossOrigin: 'anonymous',
        serverType: 'geoserver',
        hidpi: false
      }),
      zIndex: 12,
      minZoom: 15,
      maxZoom: 22
    });

    this.map?.addLayer(this.overlay_Layer_category_category);

    this.overlay_Layer_category_category['filtername'] =
      `${placeCode}_${layerConstant.parcel}:year:=:${year}`;
  }
}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initMap();
      
      const view = this.map?.getView();
      fromEventPattern(
        (handler) => view.on('change:resolution', handler),
        (handler) => view.un('change:resolution', handler)
      )
      .pipe(
        debounceTime(100),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(() => {
        //
      const zoom = this.map?.getView().getZoom();
      if(zoom >= 14) {
        if (this.mapLayer == 'default') {
            // this.basemapSwitcher('satellite');
            this.mapService.mapLayerSwitcher.next('satellite');
            }
        } else {
          if(this.mapLayer == 'satellite') {
            this.mapService.mapLayerSwitcher.next('default');
          }
       }
        //
      });
    }, 500);
    
    setTimeout(() => {
      this.allLeyars('')
      this.setupMouseEvents();
    }, 1000);
  }
  mapPanStopCondition(className: string, isEventRemove: boolean = false) {
    this.divTocontrolEventOnMap = document.querySelector(className);
    if (this.divTocontrolEventOnMap) {
      this.divTocontrolEventOnMap.addEventListener('wheel', this.preventScrollPropagation);
      this.divTocontrolEventOnMap.addEventListener("dblclick", this.preventScrollPropagation);
      this.mouseEnterHandler = () => {
        // this.map?.dragging.disable();
          this.disableEnableDragging(false);
      };
      this.divTocontrolEventOnMap.addEventListener('mouseenter', this.mouseEnterHandler);

      this.mouseEnterHandlerRemove = () => {
        // this.map?.dragging.enable();
          this.disableEnableDragging(true);
      };
      this.divTocontrolEventOnMap.addEventListener('mouseleave', this.mouseEnterHandlerRemove);
    }
    if (isEventRemove) {
      this.mouseEnterHandlerRemove();
      this.divTocontrolEventOnMap?.removeEventListener('wheel', this.preventScrollPropagation);
    }
  }
  /**
   * bboxString function to get current map view bbox string
   * @returns bbox string of current map view
   */
  bboxString() {
      const extent = this.map?.getView().calculateExtent(this.map?.getSize());
      const min = toLonLat([extent[0], extent[1]]);
      const max = toLonLat([extent[2], extent[3]]);
      const bboxString = `${min[0]},${min[1]},${max[0]},${max[1]}`;
      return bboxString;
  }
  allLeyars(legend: any) {
    // return;
    let that = this;
    that.moveEndSubscriptionMap$?.unsubscribe()
    const moveEndObservable = fromEvent(that.map, 'moveend');
    that.moveEndSubscriptionMap$ = moveEndObservable.pipe(
      debounceTime(330)
    ).subscribe(event => {
      // if (!that.activatedRoute.snapshot.queryParams['polygon'] && !that.TenantName) {

      if (that.activatedRoute.snapshot.queryParams['rid'] && that.isClusterActive) {
        const lege = GlobalContants.StoreKey.legend;
        if (!legend) legend = this.sharedService.getStoreValue(lege);
        // 
        this.multiBbox(this.bboxString(), legend);
        this.map_spinner = false;
      } else {
        const that = this;
        if (that.layer1) that.removeReportLayerSafe(that.layer1);
        if (that.layer2) that.removeReportLayerSafe(that.layer2);
        if (that.layer3) that.removeReportLayerSafe(that.layer3);
        if (that.layer4) that.removeReportLayerSafe(that.layer4);
      }
    })
  }

  /**
   * multiBbox function used to convert BBox to polygon
   * @param bound viewports map Bounds
   * @param legend Leged
   */
  multiBbox(bound: any, legend: any, type:boolean=false, layer_data:any = null) {
    // return;
    // this.seenProperties.clear();
    this.seenProperties = [];
    const cords = bound.split(',');
    let maxLat = Number(cords[0]);
    let minLon = Number(cords[1]);
    let minLat = Number(cords[2]);
    let maxLon = Number(cords[3]);

    let centLon = (maxLon + minLon) / 2;
    let centLat = (maxLat + minLat) / 2;

    if (centLon - 180 > 0) {
      centLon -= 360;
    } else if (centLon + 180 < 0) {
      centLon += 360;
    }
    this.poly = 'POLYGON((' + minLat + ' ' + minLon + ', ' + maxLat + ' ' + minLon + ', ' + maxLat + ' ' + maxLon + ', ' + minLat + ' ' + maxLon + ', ' + minLat + ' ' + minLon + '))'

    let poly1 = 'POLYGON((' + centLat + ' ' + minLon + ', ' + maxLat + ' ' + minLon + ', ' + maxLat + ' ' + centLon + ', ' + centLat + ' ' + centLon + ', ' + centLat + ' ' + minLon + '))';
    let poly2 = 'POLYGON((' + minLat + ' ' + centLon + ', ' + centLat + ' ' + centLon + ', ' + centLat + ' ' + maxLon + ', ' + minLat + ' ' + maxLon + ', ' + minLat + ' ' + centLon + '))';
    let poly3 = 'POLYGON((' + centLat + ' ' + maxLon + ', ' + maxLat + ' ' + maxLon + ', ' + maxLat + ' ' + centLon + ', ' + centLat + ' ' + centLon + ', ' + centLat + ' ' + maxLon + '))';
    let poly4 = 'POLYGON((' + centLat + ' ' + minLon + ', ' + minLat + ' ' + minLon + ', ' + minLat + ' ' + centLon + ', ' + centLat + ' ' + centLon + ', ' + centLat + ' ' + minLon + '))';

    this.polys = [poly1, poly2, poly3, poly4];
    const zoom = this.map?.getView().getZoom();
    if (!this.activatedRoute.snapshot.queryParams['polygon']) {
      if (zoom > 15 && this.isClusterActive) {
        if(!type){
          this.cancelMapApiCH$.next();
          this.getJsonData('1', poly1, legend, '',layer_data);
          this.getJsonData('2', poly2, legend, '',layer_data);
          this.getJsonData('3', poly3, legend, '',layer_data);
          this.getJsonData('4', poly4, legend, '',layer_data);
        }
      } else {
        let that=this;
        if(that.layer1)that.removeLayerBySn('1')
        if(that.layer2)that.removeLayerBySn('2')
        if(that.layer3)that.removeLayerBySn('3')
        if(that.layer4)that.removeLayerBySn('4')
      }
    } else {
      if (this.polygon_create) {
        if(this.layer1) (zoom > 15 && this.isClusterActive)?this.addReportLayerSafe(this.layer1): this.removeReportLayerSafe(this.layer1);
        if(this.layer2) (zoom > 15 && this.isClusterActive)?this.addReportLayerSafe(this.layer2): this.removeReportLayerSafe(this.layer2);
        if(this.layer3) (zoom > 15 && this.isClusterActive)?this.addReportLayerSafe(this.layer3): this.removeReportLayerSafe(this.layer3);
        if(this.layer4) (zoom > 15 && this.isClusterActive)?this.addReportLayerSafe(this.layer4): this.removeReportLayerSafe(this.layer4);
      }
    }
  }
/***
 * createSVGPattern function used to create SVG pattern for legend and Zoning
 * @param imageUrl image url for pattern
 * @param id pattern id
 */
createSVGPattern(id: string, imageUrl: string, fillColor:string, width = 20, height = 20, isreset: boolean = false, item: any = null, legends:any=null, is_category_active: boolean = false, isCategoryPatternActive: boolean = false) {
  const svgDefs = document.querySelector('svg#dynamic-pattern-defs defs');
  if (svgDefs && isreset) {
    svgDefs.innerHTML = '';
    return;
  }
  if (document.getElementById(id)) {
    return; // Prevent duplicates
  }

  const pattern = document.createElementNS('http://www.w3.org/2000/svg', 'pattern');
  pattern.setAttribute('id', id);
  pattern.setAttribute('patternUnits', 'userSpaceOnUse');
  pattern.setAttribute('width', width.toString());
  pattern.setAttribute('height', height.toString());

const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  rect.setAttribute('width', '20');
  rect.setAttribute('height', '20');
  rect.setAttribute('fill', fillColor);
  let image:any;
if(is_category_active && isCategoryPatternActive) {
  image = document.createElementNS('http://www.w3.org/2000/svg', 'image');
  image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', imageUrl);
  image.setAttribute('x', '0');
  image.setAttribute('y', '0');
  image.setAttribute('width', width.toString());
  image.setAttribute('height', height.toString());
}
  pattern.appendChild(rect);
  if(is_category_active && isCategoryPatternActive) pattern.appendChild(image);
  svgDefs?.appendChild(pattern);
}

matchQueryParems(parems:any):boolean {
  if (!parems) return false;
  const queryParams = new URLSearchParams(parems);
  const queryKeys = Array.from((queryParams as any).keys());
  const missingKeys = queryKeys.some((item:any) => !layerConstant.default_filter.has(item));
  return missingKeys;
}
 

  /**
   * Add parcel cluster on map
   * @param sn 
   * @param layer 
   */
  applySnLayer(sn: number, layer: any) {
  // console.log('applySnLayer', sn, layer);
  if (sn == 1) {
    if (this.layer1) this.removeReportLayerSafe(this.layer1);
    this.layer1 = layer;
    this.addReportLayerSafe(this.layer1);
  }
  if (sn == 2) {
    if (this.layer2) this.removeReportLayerSafe(this.layer2);
    this.layer2 = layer;
    this.addReportLayerSafe(this.layer2);
  }
  if (sn == 3) {
    if (this.layer3) this.removeReportLayerSafe(this.layer3);
    this.layer3 = layer;
    this.addReportLayerSafe(this.layer3);
  }
  if (sn == 4) {
    if (this.layer4) this.removeReportLayerSafe(this.layer4);
    this.layer4 = layer;
    this.addReportLayerSafe(this.layer4);
  }
}
removeLayerBySn(sn:number|string){
  let that=this;
  switch (sn) {
      case '1':
        that.removeReportLayerSafe(that.layer1, that);
        that.layer1=null;
        break;
      case '2':
        that.removeReportLayerSafe(that.layer2, that);
        that.layer2=null;
        break;
      case '3':
        that.removeReportLayerSafe(that.layer3, that);
        that.layer3=null;
        break;
      case '4':
        that.removeReportLayerSafe(that.layer4, that);
        that.layer4=null;
        break;
      default:
    }
}
clusterAndStrokeParcels(data: any, is_avg_transaction = false, rent_multiplier: number | null = null, color:string, sn:string|number) {
  
  const that = this;
  let lastHoverFeature: Feature | null = null;
  let hoveredId: string | null = null;
  if (!data?.features?.length) {
    that.removeLayerBySn(sn)
    return;
  }
  
  if(that.customFIlter){
    this.parcelStrokeColor = "#000000"
  }
  // that.is_rental_table // check if rental table 
  const chipFeatures: Feature[] = [];
  const strokeFeatures: Feature[] = [];
  data.features.forEach((f: any) => {
    let props = f.properties;
    // Stroke Feateure 
    let geom;
    const coords = f.geometry.coordinates;
    if (f.geometry.type === 'Polygon') {
      geom = new Polygon(coords.map((ring:any) => ring.map(([lon, lat]:any) => fromLonLat([lon, lat]))));
    } else if (f.geometry.type === 'MultiPolygon') {
      geom = new MultiPolygon(
        coords.map((polygon:any) =>
          polygon.map((ring:any) => ring.map(([lon, lat]:any) => fromLonLat([lon, lat])))
        )
      );
    }
      strokeFeatures.push(
        new Feature({
          geometry: geom
        })
      );
      // Unit name handling for chip==
      const unit_sub_type = props?.unit_sub_type;
      const unit_name = unit_sub_type?that.mapService.unitname(unit_sub_type):'';
      const usitSubtyleWidth =  unit_name?.length > 3 ? ((unit_name.length*7)+10) : 30;
      const size_unitname = unit_sub_type? usitSubtyleWidth : 15;
      props['unit_name'] = unit_name;
      props['size_unitname'] = size_unitname;
    // Only if lat/lon exist ==
    if (props.lat != null && props.lon != null) {
      let clusterF = new Feature({
          geometry: new Point(fromLonLat([props.lon, props.lat])),
          customData: props
        })
        clusterF.set("isChip", true); 
      chipFeatures.push(clusterF);
    }
  });

  const chipLayer = new VectorLayer({
    source: new VectorSource({ features: chipFeatures }),
    style: (feature) => {
      const props = feature.get("customData");
      const unit = Number(props?.unit_rate || 0);
      const prop = Number(props?.property_rate || 0);
      // 
      if(unit || prop){
        return new Style({
          image: new Icon({
            src: that.createClusterIcon(unit, prop, props.unit_name, props.width_unitname),  // chip icon
            scale: 1//hoveredId?2:1
          }),
        });
      } else {
        return undefined;
      }
    } 
  });
  const polyGonLayer = new VectorLayer({
    source: new VectorSource({ features: strokeFeatures }),
    style: (feature) => {
        return new Style({
          stroke: new Stroke({ color: this.parcelStrokeColor, width: 1 }),
          fill: new Fill({ color: 'rgba(255,87,51,0)' }),
        });
    } 
  });
  chipLayer.set("baseStyle", chipLayer);
  polyGonLayer.setZIndex(18);
  chipLayer.setZIndex(21);
const groupLayer = new LayerGroup({
    layers: [polyGonLayer, chipLayer],
  });

  // groupLayer.setZIndex(18);
  let zoom = that.map?.getView().getZoom();
  switch (sn) {
    case '1':
      that.removeReportLayerSafe(that.layer1, that);
      that.layer1 = groupLayer;
      if(zoom > 15) that.addReportLayerSafe(that.layer1, that);
      break;
    case '2':
      that.removeReportLayerSafe(that.layer2, that);
      that.layer2 = groupLayer;
      if(zoom > 15) that.addReportLayerSafe(that.layer2, that);
      break;
    case '3':
      that.removeReportLayerSafe(that.layer3, that);
      that.layer3 = groupLayer;
      if(zoom > 15) that.addReportLayerSafe(that.layer3, that);
      break;
    case '4':
      that.removeReportLayerSafe(that.layer4, that);
      that.layer4 = groupLayer;
      if(zoom > 15) that.addReportLayerSafe(that.layer4, that);
      break;
    default:
  }
}
  getJsonData(sn: any, poly: any, legend: any, type: string = '', layer_data: any = null) {
    let markerList:any = [];
    this.mapWidth = this.mapIdentifier.nativeElement.offsetWidth;
    this.mapHeight = this.mapIdentifier.nativeElement.offsetHeight;
    let zoom = (!type) ? this.map?.getView().getZoom() : null;
    let that = this;
    if (that.activatedRoute.snapshot.queryParams['rid']) {
      this.parcelStrokeColor = that.currentReportData?.map_layer?.find((item: any) => item.layer_name?.includes(that.layerEndPoint))?.color || '#939393';
      const sub = that.mapService.getGeoJsonLayerData(poly, legend, zoom, that.isLumSum.isLumsum).pipe(
        takeUntil(this.cancelMapApiCH$)
      ).subscribe((layerdata: any) => {
        layerdata.data['features'] = (layerdata?.status == 200 && layerdata?.data?.g_ids) ? that.mapService.decodeAndDecompress(layerdata.data.g_ids) : null;
        delete layerdata.data.g_ids;
        // return;
        this.clusterAndStrokeParcels(layerdata.data, false, 1 , this.parcelStrokeColor, sn)
      })
    }
  }

  getJsonDataPBF(sn: any, poly: any, layer: any, type: string = '') {}
  /**
   * showClickedParcelPopup function used to show parcel popup on map
   * @param e event
   * @param data data of clicked parcel
   * @returns
   * @memberof MapComponent
   * @description This function is used to show the parcel popup on the map when a parcel is clicked. It fetches the property data using the property UID and displays it in a popup.
   */
  async showClickedParcelPopup(evt: any, data: any) {
  let clickedPixel = evt.pixel || this.map?.getPixelFromCoordinate(evt.coordinate);
  this.removeExistingLoader(); 

  let properties = data?.properties || data || evt?.feature?.getProperties();
  let geometry = data?.geometry || evt?.feature?.getGeometry();

  if (!properties || !properties.property_uid) {
    console.warn("Property UID is missing.");
    return;
  }
const currentRequestId = ++this.parcelRequestId;
  this.closePopup();
  const olCoord = fromLonLat([data?.lon, data?.lat]);

  const loaderElement = document.createElement("div");
  loaderElement.className = "parcel-loader";
  loaderElement.innerHTML = `<div class="spinner"></div>`;

  const loaderOverlay = new Overlay({
    element: loaderElement,
    positioning: "center-center",
    stopEvent: false,
    offset: [0, 0]
  });

  loaderOverlay.setPosition(olCoord);
  this.map?.addOverlay(loaderOverlay);
  this.parcelLoaderOverlays = loaderOverlay;

  try {
    const propertyData: any = await this.mapService.getParcelInfo(properties.property_uid);
    this.map?.removeOverlay(loaderOverlay);

    if (!(propertyData.status == 200 && propertyData?.data?.length)) {
      console.warn("No Data Available");
      return;
    }
    if (currentRequestId !== this.parcelRequestId) {
      return;
    }
    // 
     const coordinate = evt.coordinate;
    let options = this.mapService.popupOptions(clickedPixel, this.mapWidth, this.mapHeight);

    properties = propertyData.data[0];
    let content;
      if (this.currentReportData?.name.includes('transaction')) {

      content = this.mapService.popup_content(
        'transaction',
        properties,
        this.currentReportData?.allowed_attributes,
        '',
        '',
        options.class_name
      );

      this.popupContent = {
        type: 'transaction',
        propertiesdata: properties,
        allowedAttributes: this.currentReportData?.allowed_attributes,
        className: options.class_name
      };

    } else {
      content = this.mapService.popup_content(
        'property',
        properties,
        this.currentReportData?.allowed_attributes,
        '',
        '',
        options.class_name
      );

      this.popupContent = {
        type: 'property',
        propertiesdata: properties,
        allowedAttributes: this.currentReportData?.allowed_attributes,
        className: options.class_name
      };
    }

    // Open popup
    this.OpenCustomPop(content,coordinate,options.class_name);

  } catch (error) {
    this.map?.removeOverlay(loaderOverlay);
    console.error("Failed to fetch property data:", error);
  }
}

closePopup() {
  if(this.popupOverlay) this.map?.removeOverlay(this.popupOverlay);
}
  /**
   * removeExistingLoaderfunction used to removed parcel loader
   */
  removeExistingLoader() {
    if(this.parcelLoaderOverlays)this.map?.removeOverlay(this.parcelLoaderOverlays);
    this.parcelLoaderOverlays = null;
  }
  viewMultiCluster(coordinates: any, lastZoom: number = 0) {
    
    this.mapPopupInstance = null;
    let that = this;
    that.mapService.tenantDataState$.next('')
    this.closePopup();
    if(this.tenantMarkerSource){
      this.tenantMarkerSource.clear();
    }

    this.tenantClusterLayer = new VectorLayer({
      source: this.tenantClusterSource,
      zIndex: 1000,
      style: (feature) => {

        const features = feature.get('features');
        let clusterCount = 0;

        features.forEach((f: any) => {
          clusterCount += f.get('value') || 0;
        });

        // Single marker → show actual marker style
        if (features.length === 1) {
          return features[0].getStyle();
        }

        // Cluster icon
        return new Style({
          image: new CircleStyle({
            radius: 14,
            fill: new Fill({ color: '#3774E8' }),
            stroke: new Stroke({ color: '#fff', width: 0 })
          }),
          text: new Text({
            text: String(clusterCount),
            fill: new Fill({ color: '#fff' }),
            font: 'bold 8px sans-serif'
          })
        });
      }
    });

    this.map?.addLayer(this.tenantClusterLayer);

    // that.individualTenantMarkers = L.layerGroup();
     coordinates.forEach((item:any) => {

        const iconUrl = item.is_layout
          ? 'assets/images/floorLayoutIcon_active.svg'
          : 'assets/images/pan_to_map_active.svg';

        const shopCount = item.shop_count > 1 ? String(item.shop_count) : '';

        const feature = new Feature({
          geometry: new Point(fromLonLat([item.lon, item.lat])),
          value: 1,
          tenantData: item
        });

        // Marker + permanent label (tooltip equivalent)
        feature.setStyle(
          new Style({
            image: new Icon({
              src: iconUrl,
              size: [27, 33],
              anchor: [0.5, 1]
            }),
            text: new Text({
              text: shopCount,
              fill: new Fill({ color: '#000' }),
              font: 'bold 12px sans-serif',
              offsetY: -15
            })
          })
        );

        this.tenantMarkerSource.addFeature(feature);
        // this.individualTenantSource.addFeature(feature);
      });

    
    if (coordinates.length == 1) {
      let content = that.mapService.popup_content('tenant', coordinates[0], that.currentReportData?.allowed_attributes, '', coordinates);
      // that.popupContent = { type: 'tenant', propertiesdata: coordinates[0], allowedAttributes: that.currentReportData?.allowed_attributes, tenantData: coordinates }
      this.panToOLMap(coordinates[0].lat, coordinates[0].lon, 18)
      setTimeout(() => {
        this.OpenCustomPop(content, fromLonLat([coordinates[0].lon, coordinates[0].lat]), 'topCenter')        
      }, 100);
    }
    // this.updateMarkers('tenant');
    if (lastZoom && !this.activatedRoute.snapshot.queryParams['amenities']) that.map?.getView().setZoom(lastZoom)
  }
  updateMarkers(type: string) {
    // return;
    let that = this;
    if (type == 'tenant') {
      if (that.map?.getView().getZoom() >= 17) {
        if (that.hasLayer(that.tenantMarkers)) {
          that.removeReportLayerSafe(that.tenantMarkers, that);
          that.addReportLayerSafe(that.individualTenantMarkers, that);
        }
      } else {
        if (that.hasLayer(that.individualTenantMarkers)) {
          that.removeReportLayerSafe(that.individualTenantMarkers, that);
          that.addReportLayerSafe(that.tenantMarkers, that);
        }
      }
    }
    if (type == 'amenities') {
      if (that.map?.getView().getZoom() >= 17) {
        if (this.amenitiesMarkers) this.removeReportLayerSafe(this.amenitiesMarkers, this);
        if (this.circleLayer) this.removeReportLayerSafe(this.circleLayer, this);
      }
    }
  }

  mapEvntSubscriber() {
    this.mapService.mapZoom.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((zoom: any) => {
      this.map?.getView().setZoom(zoom)
      this.updateMarkers('tenant');
    });
    /// Re-centering of Map when Map-Div width is being changed
    let mapDiv = document.getElementById("map") as HTMLElement;
    this.resizeObserver = new ResizeObserver(() => {
      this.map?.updateSize();
    });
    this.resizeObserver.observe(mapDiv);

    this.mapService.basemapLayer.pipe(
      takeUntil(this.unsubscribe$),
      debounceTime(300)
    ).subscribe((baseLayer: any) => {
      this.basemapSwitcher(baseLayer);
      this.fillOpacityLegend = (baseLayer == layerConstant.satellite)?0.8:1;
      if (this.activatedRoute.snapshot.queryParams['polygon']) {
        this.refreshPolygoncount('polygon')
      } else {
        this.multiBbox(this.bboxString(), '', false);
      }
    })

    /**
     * Street Name filter
     */
    this.streetNameListSub$?.unsubscribe();
    this.streetNameListSub$ = this.mapService.streetNameList.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(async (street_name: any) => {
      if (this.streetNameLayer) {
          this.map?.removeLayer(this.streetNameLayer);
      }
      if (street_name) {
        let street_nameName = await this.reportService.getStreetNameList(this.activatedRoute.snapshot.queryParams['street_name']);

        this.reportService.getStreetSearchName(street_nameName).subscribe((streets: any) => {
          this.streetNameDisplay(streets)
        })
      }
    })

    /**
     * Amenities filter
     */
    this.amenitiesItemListSub$?.unsubscribe();
    this.amenitiesItemListSub$ = this.mapService.amenitiesItemList.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((amenities: any) => {
      this.circleAnenities = [];
      if (amenities) {
        this.closePopup();
        const items = amenities.split(",");
        const resultArray = items.map((item: any) => {
          const parts = item.split("*");
          return {
            property_name: parts[0].toString().replaceAll('_', ' '),
            uid: parts[1],
            distance: parts[2],
            lat: parts[3],
            lon: parts[4],
            property_sub_cat: parts[5],
          };
        });
        this.viewAmenitiesCluster(resultArray)
      } else {
        this.updateMarkers('amenities');
      }
    });

    this.mapCoordinatesSub$?.unsubscribe()
    this.mapCoordinatesSub$ = this.mapService.mapCoordinates.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((coordinates_data: any) => {
      // return;
      this.isTenant = false;
      // this.closePopup();
      if (this.tenantMarkers)
        this.tenantMarkers.remove();
      if (this.individualTenantMarkers)
        this.individualTenantMarkers.remove();
      // console.log(coordinates_data);
      if (this.mapMarker) {
            this.removeOLMarker(this.mapMarker);
          }
      this.mapService.overlay_mapLayerEvent$.next(coordinates_data)
      if (coordinates_data?.multiLatLon) {
        this.isTenant = true;
        this.mapService.tenantName.set(coordinates_data?.tenant_name);
        this.TenantName = coordinates_data?.tenant_name;
    
        if (coordinates_data?.data?.length > 1) {
            const coords3857 = coordinates_data.data.map((point: any) =>
              fromLonLat([point.lon, point.lat])
            );

            // Create extent (bounds)
            const extent = boundingExtent(coords3857);

            // Fit map to extent
            this.map?.getView().fit(extent, {
              padding: [30, 30, 30, 30], // top, right, bottom, left
              constrainResolution: false
            });
        } else {
           this.panToOLMap(coordinates_data.data[0].lat,coordinates_data.data[0].lon,coordinates_data?.zoom || 18)
        }
      } else {
        this.TenantName = '';
        this.panToOLMap(coordinates_data.coordinates[0],coordinates_data.coordinates[1],coordinates_data?.zoom || 18,)
      }
      
      let that = this;
      let latLon: any, content: any;
      if (coordinates_data?.layer_name == "property" || coordinates_data?.layer_name == "project") {
         this.showOnMapPropData = coordinates_data;
        const properties = coordinates_data?.data;       
      
        if (properties) {

          let btn_label = (coordinates_data?.layer_name == "project") ? 'Project' : '';
          if (that.currentReportData && that.currentReportData?.name.includes('transaction')) {
            content = that.mapService.popup_content('transaction', properties, that.currentReportData?.allowed_attributes)
            that.popupContentProperty = { type: 'transaction', propertiesdata: properties, allowedAttributes: that.currentReportData?.allowed_attributes }
          } else {
            content = that.mapService.popup_content(coordinates_data?.layer_name, properties, that.currentReportData?.allowed_attributes, btn_label, '', '', coordinates_data.columnName);
            that.popupContentProperty = { type: coordinates_data?.layer_name, propertiesdata: properties, allowedAttributes: that.currentReportData?.allowed_attributes, columnName: coordinates_data.columnName }
          }
          if (this.mapMarker) {
            this.removeOLMarker(this.mapMarker);
          }
          let icon = (coordinates_data.data?.is_layout) ? "assets/images/floorLayoutIcon_active.svg" : "assets/images/pan_to_map_active.svg";
          this.mapMarker = this.addImageMarker(properties.lat, properties.lon, icon, 1, content, properties)

          setTimeout(() => {
            let coards = fromLonLat([properties.lon, properties.lat]);
            this.OpenCustomPop(content, coards, 'topCenter')

          }, 501)
        }
      }
      // Remove the last marker if it exists
      this.showMultiLatLon = [];
      this.removeCustomMaker();
      
      if (coordinates_data?.multiLatLon) {
        // Add new marker for each set of coordinates
        that.showMultiLatLon = coordinates_data?.data;
        that.viewMultiCluster(coordinates_data?.data);
      }
      if (coordinates_data?.columnName === 'p_property_name' || coordinates_data?.columnName === 'property_name' || coordinates_data?.columnName === 'property_project_name' || coordinates_data?.columnName === 'type') {
        this.mapService.tenantName.set(coordinates_data?.data?.property_name);
        this.TenantName = coordinates_data?.data?.property_name;
      }
      if (coordinates_data?.layer_name == "project") {
        this.mapService.tenantName.set(coordinates_data?.data?.project_name);
        this.TenantName = coordinates_data?.data?.project_name;
      }
      if (coordinates_data?.isNameClicked) {
        this.mapService.tenantName.set(coordinates_data?.data?.property_name);
        this.TenantName = coordinates_data?.data?.property_name;
        if (coordinates_data?.isFloorLayout) {
        } else {
          that.mapService.propertyinfotoggle.next(true);
          this.reportService.isDetailPageOpen = true
          that.mapService.selected_propertydetails.next(coordinates_data.data);
        }
      }
    })
    this.selectedReportSub$?.unsubscribe();
    this.selectedReportSub$ = this.reportService.selectedReport$.pipe(
      debounceTime(800),
    ).subscribe(isReport => {
      // return;
      this.closePopup();
      this.isReport = isReport.flag
      if (isReport.flag) {

        // if (this.layerData) this.addlayer();
        if (this.legend_data_by_group) {
          this.addMaplayer();
          let activeLayer = this.mapLayers?.filter((item: any) => item.display)
          if (activeLayer && isReport.type == 'new_report') this.mapService.overlay_mapLayer.next(activeLayer)
        }
        return;
      } else {
      }
    });

    this.sharedService.language$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(() => {
      if (!this.transaction_layer_active)
        if (this.legend_data_by_group) this.addMaplayer();
      // if (this.layerData) this.addlayer();

    });

    this.routeSub$ = this.activatedRoute.queryParams.subscribe((params) => {
      this.loadCatchmentShow = this.reLoadCatchmentShow;
      if (params['polygon']) {
        this.drawCatchmentControl = true;
        this.polygon_create = false;
      }
      this.customFIlter = this.matchQueryParems(params);
      this.checkPolygonDraw();
      let that = this;
      // if (that.lastMarker) {
      //   that.map?.removeLayer(that.lastMarker);
      // }
    })
  }

  panToOLMap(
    lat: number,
    lon: number,
    zoom: number,
    offsetY: number = 0
  ) {
    if (!this.map) return;

    const view = this.map?.getView();

    // Convert lat/lon → EPSG:3857
    const center3857 = fromLonLat([lon, lat]);

    // Set zoom first (important for pixel math)
    if (view.getZoom() !== zoom) {
      view.setZoom(zoom);
    }

    // If no offset → simple pan
    if (!offsetY) {
      view.setCenter(center3857);
      return;
    }

    // Coordinate → Pixel
    const pixel = this.map?.getPixelFromCoordinate(center3857);
    if (!pixel) return;

    // Apply Y offset
    const adjustedPixel: [number, number] = [
      pixel[0],
      pixel[1] + offsetY
    ];

    // Pixel → Coordinate
    const adjustedCoord = this.map?.getCoordinateFromPixel(adjustedPixel);
    if (!adjustedCoord) return;

    // Final pan (NO animation)
    view.setCenter(adjustedCoord);
  }


  /**
   * iconByCatGroup create icon by group
   * @param propertySubCat  property_sub_cat
   * @returns match group icon
   */
  iconByCatGroup(propertySubCat: string): string {
    const catGroup: Record<string, string[]> = {
      education: ['college', 'university', 'school'],
      healthcare: ['hospital', 'poly_clinic', 'government_hospital'],
      religious_spaces: ['mosque', 'church', 'temple'],
      hospitality: ['hotel', 'resort'],
      recreation: ['public_garden', 'sports_club', 'beach', 'marina', 'zoo_wild_life_sanctuary', 'stadium'],
      retail_entertainment: ['retail_mall', 'retail_plaza', 'entertainment_plaza', 'f_b_plaza'],
      government_civic: ['government_office', 'co_operative'],
      corporate_commercial: [],
      transport_parking: ['metro_station'],
      cultural_public_spaces: ['museum'],
      utilities_infrastructure: []
    };
    const subCategories = propertySubCat?.split('"').map(item => item.trim().toLowerCase());
    let match_categ: any = [];
    for (const [category, values] of Object.entries(catGroup)) {
      subCategories.map(subCat => {
        if (values.includes(subCat) && match_categ.indexOf(category) == -1) {
          match_categ.push(category)
        }
      })
    }

    if (match_categ.length > 1) {
      return 'assets/images/amenities/mixed-use.svg';
    } else if (match_categ.length == 1) {
      return `assets/images/amenities/${match_categ[0]}.svg`;
    } else {
      return 'assets/images/amenities/amenity_icon.svg';
    }
  }
  

initAmenityHoverOverlay() {
  const el = document.createElement('div');
  el.className = 'amenities_popup';

  this.hoverOverlay = new Overlay({
    element: el,
    offset:  [0, -33],
    positioning: 'bottom-center',
    stopEvent: false
  });

  this.map?.addOverlay(this.hoverOverlay);
}
showHoverPopup(feature: Feature, coordinate: number[], data: any = null, html: string = '') {
   const el = this.hoverOverlay.getElement() as HTMLElement;
  el.innerHTML = html;

  this.hoverOverlay.setPosition(coordinate);
}

hideHoverPopup() {
  this.hoverOverlay.setPosition(undefined);
  this.hoveredFeature = null;
}

viewAmenitiesCluster(coordinates: any[], lastZoom: number = 0) {
  if (this.amenitiesMarkers) this.map?.removeLayer(this.amenitiesMarkers);
  if (this.circleLayer) this.map?.removeLayer(this.circleLayer);

  // Reset sources
  this.amenitiesSource = new VectorSource();
  this.circleSource = new VectorSource();
  this.circleAnenities = [];

  this.amenitiesMarkers = new VectorLayer({
    source: this.amenitiesSource,
    zIndex: 17
  });

  this.circleLayer = new VectorLayer({
    source: this.circleSource,
    zIndex: 17
  });

  this.map?.addLayer(this.circleLayer);
  this.map?.addLayer(this.amenitiesMarkers);

  coordinates.forEach((item, i) => {
    const center = fromLonLat([item.lon, item.lat]);
    const cat_icon = this.iconByCatGroup(item.property_sub_cat);

    const markerFeature = new Feature({
      geometry: new Point(center),
      amenityData: item,
      index: i
    });

    markerFeature.setStyle(
      new Style({
        image: new Icon({
          src: cat_icon,
          anchor: [0.5, 1],
          scale: 1
        })
      })
    );

    this.amenitiesSource.addFeature(markerFeature);
    const radius = Number(item.distance); // ensure it's a number

    const circleGeom = new Circle(center, radius);

    const circleFeature = new Feature(circleGeom);

    circleFeature.setStyle(
      new Style({
        stroke: new Stroke({
          color: '#000000',
          width: 2
        }),
        fill: new Fill({
          color: 'rgba(255, 0, 0, 0.0)' // transparent
        })
      })
    );

    this.circleSource.addFeature(circleFeature);
    this.circleAnenities.push(circleFeature);
    // setTimeout(() => {
      const html = this.mapService.createPoup('amenities', item);
      this.showAmenityPoup(html, center, null);
      this.initAmenityHoverOverlay();
    // }, 100);

  }); // loop end

  // this.map?.renderSync();
  if (!this.activatedRoute.snapshot.queryParams['street_name']) {
    this.fitMapToCircles(this.circleAnenities);
  }

  this.moveEventHandlerAmenityStreet();

  setTimeout(() => this.removeAmenitiesPopups(), 5000);

}
moveEventHandlerAmenityStreet() {
  if (this.amenityStreetMoveKey) {
    return; 
  }

  this.amenityStreetMoveKey = this.map?.on(
    'pointermove',
    this.onAmenityStreetPointerMove.bind(this)
  );
}
onAmenityStreetPointerMove(evt: any) {
  // Hover tooltip
    // this.map?.on('pointermove', (evt: MapBrowserEvent) => {
      if (this.isDrawingCatchment) return;

      const feature = this.map?.forEachFeatureAtPixel(
        evt.pixel,
        (f: Feature) => f,
        { hitTolerance: 8 }
      );

      // Hovering on amenity
      let item = feature ? feature.get('amenityData') : null;
      if (item) {
        // console.log('hovering on amenity', feature.get('amenityData'));
        if (this.hoveredFeature !== feature) {
          this.hoveredFeature = feature;
          let center = fromLonLat([item.lon, item.lat]);
          const data = feature.get('amenityData');
          const html = this.mapService.createPoup('amenities', data);
          this.showHoverPopup(feature, center, data, html);
        }

        this.viewport.classList.add('cursor-pointer');
        return;
      }
          let hit = false;
          const pixel = evt.pixel;
          const featureStreet = this.map?.forEachFeatureAtPixel(pixel, (f: Feature) => f, {
            hitTolerance: 8,
            layerFilter: (layer: any) => layer === this.streetLayer
          });

          if (featureStreet) {
            const streetName = this.reportService.getStreetNameList(this.activatedRoute.snapshot.queryParams['street_name']);
            hit = true;
            const props = featureStreet.getProperties();
            const property_name = props?.street_name?.[this.current_lang_id] || props?.street_name?.[1] || '';
            const distance = streetName[props?.street_name?.[1]];
            const data = { property_name, distance };
            this.mapWidth = this.mapIdentifier.nativeElement.offsetWidth;
            this.mapHeight = this.mapIdentifier.nativeElement.offsetHeight;
            const content = this.mapService.createPoup('amenities', data);
            // that.closePopup();
            // console.log('hovering on street', props);
            this.viewport.classList.add('cursor-pointer');
            // this.showAmenityPoup(content, evt.coordinate, null);
            this.showHoverPopup(featureStreet, evt.coordinate, data, content);
            return;
          }

      // Mouse out
      // this.viewport.classList.remove('cursor-pointer');
      this.hideHoverPopup();
    // });

}
  showAmenityPoup(content: any, coordinate: any, options = null, isStreet:boolean = false) {
    const popupElement = document.createElement('div');
    popupElement.className = 'amenities_popup';
    popupElement.innerHTML = content;

    const overlay = new Overlay({
      element: popupElement,
      positioning: 'bottom-center',
      stopEvent: false,
      offset: isStreet ? [0, -10] : [0, -33]
    });

    overlay.setPosition(coordinate);
    this.map?.addOverlay(overlay);

    // Store each overlay separately
    this.amenitiesPopups.push(overlay);
  }


  removeAmenitiesPopups() {
    if (this.amenitiesPopups && this.amenitiesPopups.length) {
      this.amenitiesPopups.forEach((popup: any) => {
        try { this.map?.removeOverlay(popup); } catch (e) { }
      });
      this.amenitiesPopups = [];
    }
  }

  streetNameDisplay(street_name: any) {
    if(street_name?.data && street_name.data?.length == 0) return;
    let that = this;
    // Remove previous OL layer if present
    if (that.streetNameLayer && this.map?.getLayers().getArray().includes(that.streetNameLayer)) {
      this.map?.removeLayer(that.streetNameLayer);
    }
    const streetName = this.reportService.getStreetNameList(this.activatedRoute.snapshot.queryParams['street_name']);
    const geojson = street_name.data[0];
    const format = new GeoJSON();
    const features = format.readFeatures(geojson, {
      featureProjection: this.map?.getView().getProjection()
    });

    const streetSource = new VectorSource({ features });
    this.streetLayer = new VectorLayer({
      source: streetSource,
      style: new Style({
        stroke: new Stroke({ color: '#000000', width: 5 }),
        fill: undefined
      }),
      zIndex: 17
    });

    this.streetNameLayer = this.streetLayer;
    this.map?.addLayer(this.streetNameLayer);

    // Unbind previous pointer listener if any
    if (this.streetNamePointerKey) {
      try { unByKey(this.streetNamePointerKey); } catch (e) { }
      this.streetNamePointerKey = null;
    }

    geojson.features.forEach((feature: any) => {
      const property_name = feature.properties?.street_name?.[that.current_lang_id] || feature.properties?.street_name?.[1] || '';
      const distance = streetName[feature.properties?.street_name?.[1]];
      const data = { property_name, distance };

      // Extract coordinate from feature geometry (first point for line/polygon)
      let coordinate: any;

      if (feature.geometry.type === 'MultiLineString' && feature.geometry.coordinates?.[0]?.length) {
        coordinate = feature.geometry.coordinates[0][0];
      }

      // Convert from [lon, lat] to map projection if valid
      if (coordinate && Array.isArray(coordinate) && coordinate.length === 2) {
        const projCoord = fromLonLat(coordinate);
        const content = that.mapService.createPoup('amenities', data);
        this.showAmenityPoup(content, projCoord, null, true);
        this.initAmenityHoverOverlay();
      }
    })

    if (!this.activatedRoute.snapshot.queryParams['amenities']) {
      // Fit map to street layer bounds
      const streetSource = this.streetNameLayer.getSource();
      const extent = streetSource.getExtent();
      if (extent && !olExtent.isEmpty(extent)) {
        this.map?.getView().fit(extent, { padding: [100, 50, 100, 50], constrainResolution: false });
      }
    } else {
      // Store bounds and fit to circles with street context
      const streetSource = this.streetNameLayer.getSource();
      this.streetBounds = streetSource.getExtent();
      that.fitMapToCircles(that.circleAnenities, this.streetBounds);
    }
    this.moveEventHandlerAmenityStreet();
    setTimeout(() => { that.removeAmenitiesPopups(); }, 5000);
  }

  /**
   * fitMapToCircles use to mapzoom
   * @param circles List of amenities redius circle
   */
  fitMapToCircles(circles: any, street: any = null): void {

    // Build extent from circle features
    let extent: any = null;
    if (circles) {
      circles.forEach((circleFeature: any) => {
        const geom = circleFeature.getGeometry?.();
        if (geom) {
          const featureExtent = geom.getExtent();
          if (extent) {
            extent = olExtent.extend(extent, featureExtent);
          } else {
            extent = featureExtent;
          }
        }
      });
    }
    
    if(street){
      extent = olExtent.extend(extent, street);
    }

    // Fit map to extent with padding
    if (extent && !olExtent.isEmpty(extent)) {
      this.map?.getView().fit(extent, {
        padding: [30, 30, 30, 30],
        constrainResolution: false
      });
    }
  }


  basemapSwitcher(value?: string) {
  this.mapLayer = value ?? 'default';

  const zoom = this.map?.getView().getZoom();

  if (value === 'satellite') {
      if(this.estaterMapLayer && this.estaterMapLayer.getVisible()) {
        this.estaterMapLayer.setVisible(false);
      }
      this.base_Layer.setVisible(false);
      this.satelliteLayer.setVisible(true);
  } else {
    this.base_Layer.setVisible(true);
    this.satelliteLayer.setVisible(false);
    if(this.estaterMapLayer && !this.estaterMapLayer.getVisible()) {
        this.estaterMapLayer.setVisible(true);
      }
      
  }
  // this.baseLayerFunction(zoom);
}



  addMaplayer(isRateControl: boolean = false) {
    this.legendLayerSub$?.unsubscribe();
    let that = this;
    let queryParam = this.reportService.queryParams;
    if (queryParam?.year) {
      this.layer_year = queryParam?.year.split(',').map(Number)
        .sort(function (a: any, b: any) { return a - b }).pop();
    } else if (!queryParam?.year) {
      this.layer_year = new Date().getFullYear();
    }
    // return;
    that.mapLegendmenu();
    // let legend_data: any = that.layerData?.legend.filter((r: any) => r.display == true) || [];
    let legend_data: any = that.legend_data_by_group?.filter((r: any) => r.display == true) || [];
    let place_id = that.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceId);
    let store_name = 'MI';//that.layerData?.store_name;
    let layer_name = `${store_name}:${that.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode)}_${this.layerEndPoint}`;
    let url = `${environment.geoestater}wms-layer?place_id=${place_id}&token=${environment.user_token}&store=${store_name}`;
    
    // that.layerFilter();
    let filter_polygon = null;
    if (!that.polygon_create) {
      if (that.activatedRoute.snapshot.queryParams['rid']) {
        that.getSavedCatchment()
        // if(this.map && this.map?.hasLayer(this.report_countLayer)){ this.map?.removeLayer(this.report_countLayer) }
        if (that.count_LayerSub$) that.count_LayerSub$.unsubscribe();
        that.count_LayerSub$ = that.mapService.getReportCount(filter_polygon, that.isLumSum.isLumsum).subscribe((layerdata: any) => {
          let data = layerdata.data;
          that.reportCountLayer(data, layerdata?.is_avg_transaction, layerdata?.rent_multiplier);

        })
      }
    } else if (that.polygon_create && isRateControl) {
      this.checkPolygonDraw(isRateControl);
    }
if(that.legendLayerSub$)that.legendLayerSub$.unsubscribe();
    // that.legendLayerSub$ = that.mapService.legendLayer.pipe(
    that.legendLayerSub$ = that.mapService.legendLayerGroup.pipe(
      takeUntil(this.unsubscribe$),
      distinctUntilChanged()
    ).subscribe((data: any) => {
      legend_data = data;
      // this.currentReportData.legend= legend_data;
      if(that.map) {
        this.selectedLegends = legend_data;
        that.legendMapLayer([], legend_data);
        that.addWmsZoningCategoryLayers(legend_data);
        // let item = legend_data?.map((item: any) => item.legend_type);
        //--let item = that.mapService.currentLegendState();
        //--that.createSVGPattern('','','', 0, 0, true, item); // Reset SVG pattern
        if (this.activatedRoute.snapshot.queryParams['polygon']) {
          this.refreshPolygoncount('polygon', true)
        } else {
          that.multiBbox(that.bboxString(), '', false, legend_data);
        }
      }
    });
    // let counter = 0;//added for testing
    let init = true;
    if(!this.overlayMapLayerSubscription$) {
      that.overlayMapLayerSubscription$ = that.mapService.overlay_mapLayer.pipe(
        takeUntil(this.unsubscribe$)
      ).subscribe((layer: any) => {
        const exists = layer.some((item: any) => item.isshowClicked === false)
        if(exists) {
          layer = layer.filter(
            (item: any) => item.isshowClicked !== false
          );
        }
        if(!init){
          if (![layerConstant.category, layerConstant.zoning].includes(layer[0]?.legend_type)) that.overlayLayers(layer, exists)
          this.selectedMaplayer = layer;
        }
        init = false;
      })
    }
    this.map_spinner = false;
  }
  legendMapLayer(layer: any = [], legend_data:any=null) {
    if(this.projectLayer_pbf) layer = this.projectLayer_pbf;
    let isProject = layer?.find((item: any) => item.layer_name == layerConstant.miprojects && item.display);
    let currentReportDataLegend = legend_data? legend_data?.filter((item: any) => item.display) || [] :this.currentReportData.legend?.filter((item: any) => item.display) || [];
    this.currentReportData.legend = currentReportDataLegend;//= legend_data? legend_data?.filter((item: any) => item.display) || [] :this.currentReportData.legend?.filter((item: any) => item.display) || [];
    if (isProject) {
      // circle
      layerConstant.miprojects_labels[0].data.forEach((item: any) => {
        item['color'] = isProject.color;
      })
      this.reportService.mapLayerData.set(layerConstant.miprojects_labels);
      this.legend_data_by_group = [...layerConstant.miprojects_labels, ...currentReportDataLegend];
    } else {
      this.legend_data_by_group = currentReportDataLegend;
      this.reportService.mapLayerData.set([]);
    }
    
    this.legend_data_by_group = this.addPaternToLegend(this.legend_data_by_group);
    this.reportService.mapLayerDataCat.set(this.legend_data_by_group);
    setTimeout(()=>{this.legendCount()},0);
  }
  addPaternToLegend(legend: any) {
    let zoning = legend?.find((item: any) => (item.legend_type).toLowerCase() == layerConstant.zoning && item.display);
    let category = legend?.find((item: any) => (item.legend_type).toLowerCase() == layerConstant.category && item.display);
    let isPattern = !!(zoning && category);
     let  modifiedLegend = this.modyfylegendFlag(legend, isPattern);
    return modifiedLegend;
  }
  modyfylegendFlag(legend: any, isPattern:boolean=false) {
    return legend.map((item: any) => {
        if((item.legend_type).toLowerCase() == layerConstant.category) {
          item.data.forEach((data: any) => {
            let categoryPattern = this.mapService.resolveCategoryGroup(data.category, this.cityCode, true);
            data['image']=CATEGORY_GROUP_NAMES_LEGEND[categoryPattern];
            data['pattern'] = true;
          })
          return item
        } else {
          return item
        }
      })
  }
  overlayLayers(layer: any, exists: null | boolean = null) {
// console.log(layer)
  const that = this;
  if (that.projectLayer){
      that.removeProjectLayer(true, true, true);
    }  
    if (Object.keys(that.Pbf_OverlayLayer).length > 0) {
        that.removeAllPbfVectorOverlays(false, '', that);
      }
  const place_id = this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceId);

  // REMOVE PREVIOUS
  if (this.overlay_Layer && this.hasLayer(this.overlay_Layer)) this.removeReportLayerSafe(this.overlay_Layer);

  this.overlay_Layer = new LayerGroup({
    layers: []
  });
  let parcel_layer: any = this.property_details_pbf, property_details_pbf: any = this.property_details_pbf;
  if(exists){
    parcel_layer = layer.find(
      (item: any) => item.layer_name === this.layerEndPoint
    );
    this.property_details_pbf = parcel_layer;
      const property_details_pbf = parcel_layer?.display ?  parcel_layer : null
    let zoning_layer_Active = this.property_land_zoning_activelayer?.display || false;
    if(!property_details_pbf && !zoning_layer_Active) {
      this.removeReportLayerSafe(this.parcelsLayerOL);
      // this.parcelsLayerOL = null;
    } else if (!property_details_pbf && zoning_layer_Active) {
      this.addParcelLayerMVT(parcel_layer);
    }
  }
  this.projectLayer_pbf = layer?.filter(
    (item: any) => item.layer_name?.includes(layerConstant.miprojects)
  );

  // Legend update
  this.legendMapLayer();
  layer.forEach((overlay: any, index: any) => {
    if (overlay?.type === "wms") {

      const placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);

      let layer_name = overlay.layer_name;
      let overlay_storename = '';

      if (overlay.store_name === layerConstant.mi_stroe) {
        layer_name = `${placeCode}_${layer_name}`;
        overlay_storename = overlay.store_name;
      } else {
        overlay_storename = `${placeCode}_${overlay.store_name}`;
      }

      const overlay_url =
        `${environment.geoestater}wms-layer?place_id=${place_id}&token=${environment.user_token}&store=${overlay_storename}`;

      // Build WMS params
      const wmsParams: any = {
        LAYERS: layer_name,
        FORMAT: "image/png",
        TRANSPARENT: true,
        STYLES: overlay?.layer_style || "",
      };

      if (overlay?.layer_style) {
        const color = overlay.color ? overlay.color.replace("#", "") : "";

        if (overlay.layer_style === layerConstant.env_based_style) {
          wmsParams.env =
            `FILL_COLOR:${color};FILL_OPACITY:0.5;STROKE_WIDTH:1;STROKE_COLOR:939393;STROKE_OPACITY:0.9`;
        } else {
          wmsParams.env = `overlay_color:${color}`;
        }
      }

      // OL Tile WMS Layer
      let wmsLayer: any;
      let isGeoServerSource = overlay?.isGeoServerSource ?? true;
      let rasterLayerUrlEstater = `${environment.estaterMapUrl}/all/maps/${placeCode.toLowerCase()}/${overlay.layer_name}/{z}/{x}/{y}.png?token=${this.vectorLayerToken}`;
      if(isGeoServerSource === false){
        if(overlay.layer_name === layerConstant.road) rasterLayerUrlEstater+='&lang='+this.current_lang;
        wmsLayer = new TileLayer({
          source: new XYZ({
            url: rasterLayerUrlEstater,
            crossOrigin: 'anonymous',
            tilePixelRatio: 1
          }),
          minZoom: overlay.minZoom ?? 0,
          maxZoom: overlay.maxZoom ?? 20,
          zIndex: 12
        });
      } else {
        wmsLayer = new TileLayer({
        source: new TileWMS({
          url: overlay_url,
          params: wmsParams,
          serverType: "geoserver",
          crossOrigin: "anonymous",
          hidpi: false
        }),
        minZoom: overlay.minZoom ?? 0,
        maxZoom: overlay.maxZoom ?? 20,
        zIndex: 12
      });
      }

      // Add to overlay group
      this.overlay_Layer.getLayers().push(wmsLayer);
    } else if (overlay?.layer_name) {

      // SAME LOGIC AS addPbfOverlayLayer()
      if (
        overlay?.legend_type != layerConstant.category &&
        overlay?.layer_name
      ) {
        //-- 
        this.addPbfOverlayLayer(overlay, index, property_details_pbf);
      }
    }
  });

  // PARCEL ACTIVATION HANDLING

  if (!layer.length || !parcel_layer) {
    this.parcelLayerActive = false;
  } else {
    this.parcelLayerActive = true;
  }

  // ADD OVERLAY GROUP TO MAP
  this.map?.addLayer(this.overlay_Layer);
}
  steCurrentBounds() {
    // let mapbounds = this.map?.getBounds();
    let mapbounds = this.map?.getView().calculateExtent(this.map?.getSize());
    this.mapService.mapCurrentMapState.set(mapbounds);
    const zoom = this.map?.getView().getZoom();
    this.mapService.mapCurrentMapStateZoom.set(zoom);
  }
  mapLayerZoomlimit(flag: boolean = true) {
    // return;
    let that = this;
    if (that.TenantName) {
      if (that.report_countLayer) that.removeReportLayerSafe(that.report_countLayer, that);
      return;
    }
    const zoom = this.map?.getView().getZoom();
    if (!that.polygon_create) { /// Initial WMS Zoom Level logic
      if (zoom >= 16) {
        if (that.report_countLayer && flag) that.removeReportLayerSafe(that.report_countLayer, that);
        if (that.parcelLayerWms) that.addReportLayerSafe(that.parcelLayerWms, that);
      }
      else {
         that.removeReportLayerSafe(that.parcelLayerWms, that);
        if (that.report_countLayer && flag) that.addReportLayerSafe(that.report_countLayer, that);
      }
    } else {
      // that.map?.removeLayer(that.report_countLayer);
      if (this.polygon_WKT?.length > 0 || zoom >= 16) {
        if (that.report_countLayer) that.removeReportLayerSafe(that.report_countLayer, that);
      }
      else that.addReportLayerSafe(that.report_countLayer, that);
      if (that.parcelLayerWms) that.addReportLayerSafe(that.parcelLayerWms, that);
      // if(that.parcelLayerPbf) that.map?.addLayer(that.parcelLayerPbf);
    }
  }

  removeLayers(isReportChange: any = '') {
    // return;
    this.TenantName = '';
    if (this.amenitiesMarkers)
      this.removeReportLayerSafe(this.amenitiesMarkers, this);
    if (this.circleLayer)
      this.removeReportLayerSafe(this.circleLayer, this);
    if (this.tenantMarkers)
      this.removeReportLayerSafe(this.tenantMarkers, this);
    if (this.individualTenantMarkers)
      this.removeReportLayerSafe(this.individualTenantMarkers, this);
    let report_type = isReportChange && isReportChange?.type;//new_report
    if (this.Orig_parcelLayerWms) // Property layer
      this.removeReportLayerSafe(this.Orig_parcelLayerWms, this);
    if (this.parcelLayerWms) // Property legend layer
      this.removeReportLayerSafe(this.parcelLayerWms, this);
    if (this.pbfParcelLayer) // property pbf layer (parcel boundry)
      this.removeReportLayerSafe(this.pbfParcelLayer, this);
    if (this.report_countLayer) { // report count
       this.removeReportLayerSafe(this.report_countLayer, this);
      this.report_countLayer = null;
    }
    if (this.projectLayer) // Project layers
        this.removeProjectLayer(true, true, true);

    if (report_type == 'new_report') {
      if(this.overlay_Layer_category_category){
        this.removeReportLayerSafe(this.overlay_Layer_category_category, this);
      }
      if(this.overlay_Layer_category_zoning){
        this.removeReportLayerSafe(this.overlay_Layer_category_zoning, this);
      }
      if (this.parcelLayerPbf) // Property legend layer
        this.removeReportLayerSafe(this.parcelLayerPbf, this);
      if (this.overlay_Layer) // pbf and WMS layer group (block layer == wms layer/ neigh layer == pbf)
        this.removeReportLayerSafe(this.overlay_Layer, this);
      if (this.Pbf_OverlayLayer) {// combination of markeer and bounry layer for pbf overlay (neighbourhoods and project )
        // this.Pbf_OverlayLayer = {};
        if (Object.keys(this.Pbf_OverlayLayer).length > 0) {
          this.removeAllPbfVectorOverlays(false, '', this);
        }
      }

      // if (this.projectLayer) // Boundry layers
      //   this.removeProjectLayer(true, true, true);
      
        //remove draw on report change
      if(!this.polygon_create) this.drawSource.clear();

      if (this.map && !this.polygon_create) this.map?.getView().setZoom(10);
    }
  }

  getMaxYear(){
    let year = (this.activatedRoute.snapshot.queryParams['year']) ? this.reportService.yearMaxValue((this.activatedRoute.snapshot.queryParams['year']).toString()) :
      (this.activatedRoute.snapshot.queryParams['transaction_date']) ? this.reportService.getTTMmaxYear(this.activatedRoute.snapshot.queryParams['transaction_date']) : new Date().getFullYear();
      return year;
  }
  
  addParcelLayerMVT(data:any=null, is_landZoning:boolean=false, activeZoningLayer:boolean=false) {
    // return;
    // console.log(data)
    let parcel_layer_Active = !!this.property_details_pbf?.display;
    this.parcel_layer_Active = parcel_layer_Active;
    // let zoning_layer_Active = this.property_land_zoning_activelayer?.display && !this.propertyLandZoningSource || false;
    let zoning_layer_Active = !!this.property_land_zoning_activelayer?.display && !this.propertyLandZoningSource;
    if(!parcel_layer_Active && !zoning_layer_Active){
      this.removeReportLayerSafe(this.parcelsLayerOL);
      return;
    } 
    this.removeReportLayerSafe(this.parcelsLayerOL);
    let color = this.property_details_pbf?.color  || data?.color || 'rgba(112,111,111,0.67)';
    let isParcelActive = !!(this.property_details_pbf)
    
    const ZONING_FILL_COLORS: Record<string, string> = {};
    const legendColors: Record<string, string> = this.sharedService.getStoreValue(GlobalContants.StoreKey.zoning) || null;
    if(zoning_layer_Active){
        legendColors && Object.entries(legendColors).forEach(([key, hex]:any) => {
          ZONING_FILL_COLORS[key] = this.hexToRgba(hex, 0.7, true);
        });
      }
    let hoveredId: number | null = null;
    if(this.hasLayer(this.parcelsLayerOL) || this.parcelsLayerOL) {
      // this.addReportLayerSafe(this.parcelsLayerOL)
      // return;
      this.removeReportLayerSafe(this.parcelsLayerOL);
      this.parcelsLayerOL=null;
    }
    this.cityCode = (this.cityCode || this.storeService.get(GlobalContants.StoreKey.placeCode) || '').toLowerCase();
    const city_code = (this.cityCode || 'ryd').toLowerCase();
    const year = this.getMaxYear() || new Date().getFullYear();

    let url = `${environment.estaterMapUrl}/all/tiles/${city_code}/${year}/{z}/{x}/{y}?token=${this.vectorLayerToken}`;
    let mvtPbfLayerSource = new VectorTileSource({
      format: new MVT(),
      url: url
    });
    this.parcelsLayerOL = new VectorTileLayer({
      source: mvtPbfLayerSource,
      renderMode: 'vector',
      declutter: false,
      zIndex: 13,
      properties: { layerName: "parcels" },
      style: (feature: FeatureLike) => {
        const props:any = feature.getProperties();
        if (props['layer'] == "parcels") {
            const zoningKey = props.zoning1?.toLowerCase();
            const fillColor = ZONING_FILL_COLORS[zoningKey] || "rgba(179, 179, 179, 0)";
            const gid = props['property_id'];
            if (gid === hoveredId) {
              return  new Style({
                stroke: new Stroke({ color: '#000000', width: 1.2 , lineDash: [4, 6] }),
                fill: new Fill({ color: (zoning_layer_Active)? fillColor :'rgba(255,87,51,0)' }),
                zIndex: 20
              });
            }
            return new Style({
              stroke: new Stroke({ color: color, width: 1 }),
              fill: new Fill({ color: (zoning_layer_Active)? fillColor : 'rgba(255,87,51,0)'}),
              zIndex: 13 
            });
          }
          return undefined;
        }
    });
    this.addReportLayerSafe(this.parcelsLayerOL)

    this.map?.on('pointermove', (evt: MapBrowserEvent<any>) => {
      
      if(this.mapZoomCurrentValue <= 13 && !this.parcelsLayerOL) return; // click disabled below zoom 15
      if (this.isDrawingCatchment) return;
      
      const feature = this.map?.forEachFeatureAtPixel(
        evt.pixel,
        (f:FeatureLike) => f,
        { layerFilter: (layer: Layer) => layer === this.parcelsLayerOL }
      );
    if (!feature || feature.get('layer') !== 'parcels') {
        if (hoveredId !== null) hoveredId = null;
        // this.map?.getTargetElement().style.cursor = '';
        this.parcelsLayerOL.changed();
        return;
      }

      const props = feature.getProperties();
      if (props.layer == 'parcels'){
        if(!that.parcel_layer_Active){
          if (that.viewport.classList.contains('cursor-pointer')) {
            that.viewport.classList.remove('cursor-pointer');
          }
          return;
        } 
        // this.map.getTargetElement().style.cursor = 'pointer';
        that.viewport.classList.add('cursor-pointer');
      }
      // console.log("Hovering parcel feature with data:", props);
      const gid = props.property_id;
      if (gid !== hoveredId) {
        hoveredId = gid;
        this.parcelsLayerOL.changed();  
      }
    });
let that =this;
    // Click Logic -----
    this.map?.on('click', (evt:MapBrowserEvent) => {
      if(this.catchmentPolyGonDrawStart) return;
          if(this.mapZoomCurrentValue < 14) return;
          let hovered: FeatureLike[] = [];
          try {
            hovered = that.map?.getFeaturesAtPixel(evt.pixel) || [];
          } catch {
            return;
          }
          
          evt.stopPropagation();
          evt.preventDefault();
          const feature = hovered.find((f: FeatureLike) => f instanceof Feature) as Feature | undefined;
          if (feature) {
            if(feature.get('type') === 'marker') {
              const properties = feature.get('properties');
              // console.log("Marker clicked: ", properties);
              const coordinate = fromLonLat([properties.lon, properties.lat]);
              const btn_label = properties?.proj_uid ? 'Project' : properties.neigh_uid ? 'Neighbourhood' : 'property';
              const layer_name = properties?.proj_uid ? 'project' : properties.neigh_uid ? 'neighbourhoods' : 'property';
              const content = this.mapService.popup_content(layer_name, properties, this.currentReportData?.allowed_attributes, btn_label, '', '', properties.columnName);
              this.OpenCustomPop(content, coordinate, 'topCenter');
              return;
            }
          }
          const chipFeature = this.map?.forEachFeatureAtPixel(
            evt.pixel,
            (feature: FeatureLike) => {
              return feature.get("isChip") ? feature : null;
            },
            { hitTolerance: 5 }
          );
      if (chipFeature) {
        const props_data = chipFeature.get("customData") || null;
        this.showClickedParcelPopup(evt,props_data )
        return; 
      }
    if(!this.parcel_layer_Active ) return;
      //  Only runs if chip above did NOT match
      const parcelFeature = this.map?.forEachFeatureAtPixel(
        evt.pixel,
        (f:FeatureLike) => f,
        {
          hitTolerance: 5,
          layerFilter: (layer:Layer) => layer === this.parcelsLayerOL,
        }
      );

      if (parcelFeature) {
        let parcelData = parcelFeature.getProperties() || null
        this.showClickedParcelPopup(evt,parcelData )
      }
    });
  }
  /**
   * hex to alph color converter  
   * @param hex 
   * @param alpha 
   * @returns 
   */
  hexToRgba(hex: string="#664FD9", alpha: number, rgba: boolean = false): any {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return rgba ? `rgba(${r}, ${g}, ${b}, ${alpha})` : [r, g, b, alpha];
  }
  /**
   * PBF Overlay Layer
   * @param data
   * @param index
   */
  addPbfOverlayLayer(data: any, index: any, property_details_pbf: any = null) {
    let that = this;
    let feature_uid_store: any = [];
    let layer_color = `${data?.color}`;
    let layer_rgba_color = that.hexToRgba(data?.color, 0.3);
    let _year:number = Number(that.getMaxYear());
    //if (data?.layer_name == 'neighbourhoods') that.Pbf_OverlayLayer[index]['minZoom'] = 13; //Avoid Neighbourhood Markers Overlapping
    let store_name: string = `${this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode)}_${data?.store_name}`;
    let layer_name: string = `${data?.layer_name}`;
    if (data?.layer_name == layerConstant.miprojects || data.store_name == layerConstant.mi_stroe) {
      store_name = `${data?.store_name}`;
      layer_name = `${this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode)}_${data?.layer_name}`;
    }
    // layer_name
    if (data?.layer_name?.includes(that.layerEndPoint)) {
        if(environment.get_MVT_parcelLayer){
          this.addParcelLayerMVT(property_details_pbf)
        } else {
          // this.addParcelPbfLayer(data, property_details_pbf) 
        }
      return;
    }

    // return;
    // &CQL_FILTER=year=${filterYear}
    let url = `${environment.geoestater}pbf-layer?store=${store_name}&layer=${layer_name}&token=${environment.user_token}&points={z}/{x}/{-y}.pbf`;
    // let url = `https://geoestater.gisworld.in/pbf-layer?store=${store_name}&layer=${layer_name}&token=TlRBPU0yTTJaVEJpT0dFNVl6RTFNakkwWVRneU1qaGlPV0U1T0dOaE1UVXpNV1E9TlRjNE1HVXdPRE00Wm1KaFpHSTRNMlF3WXpjeFpUQm1aV1ZqTmpSbU5EZz1NMk0yWlRCaU9HRTVZekUxTWpJMFlUZ3lNamhpT1dFNU9HTmhNVFV6TVdRPTE1Njk0NzgwNTg=&points={z}/{x}/{-y}.pbf`;
    let current_langID = this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrentLangID);
    let zindex = data.layer_name == 'neighbourhoods' ? 12: 9;
    let subcats = that.activatedRoute.snapshot.queryParams['property_category']?that.activatedRoute.snapshot.queryParams['property_category'].split(',').map((x: string) => x.trim().toLowerCase()):[];
    let mapZoom = that.map?.getView().getZoom();
    // return;
    // Start project layer 
    if (data?.layer_name == layerConstant.miprojects) {
        that.projectTileFeatures = [];
        that.projectLayer = new VectorTileLayer({
          source: new VectorTileSource({
            url,
            format: new MVT(),
          }),
          minZoom: data?.minZoom,
          maxZoom: data?.maxZoom,
          zIndex: zindex,

        // vectorTileLayerStyles
        style: (feature, resolution) => {
          const properties:any = feature.getProperties();
          const category = properties?.category;
          const uid = properties?.proj_uid ?? properties?.neigh_uid ?? null;

          // CATEGORY FILTERING ===========
          // if (data?.layer_name == layerConstant.miprojects) {
          // console.log('Filtering project feature:', properties, 'against subcats:', subcats, _year);
              const allowedSubcats: string[] = properties?.category?.split(',') || [];
              const hasValidSubcat = allowedSubcats?.length && allowedSubcats?.some(cat => subcats.includes(cat.toLowerCase()));
              if (!hasValidSubcat && subcats.length > 0) {
                return undefined;  
              }
              if(_year !== properties?.year){
                return undefined;
              }
          // }
          const isHovered = uid && uid === this.hoveredProjectUid;
          // BASE POLYGON STYLE
          return new Style({
            stroke: new Stroke({
              color: layer_color,
              width: 3,
              lineDash: isHovered ? undefined : [3, 6]
            }),
            fill: isHovered?new Fill({ color: layer_rgba_color }):new Fill({ color: [0, 0, 0, 0] })
          });
        },
      });
    // OL equivalent of onEachFeature
    let tileFeatures:any;
        that.projectLayer.getSource().on("tileloadend", (evt:any) => {
          const tile = evt.tile;
          tileFeatures = tile.getFeatures ? tile.getFeatures() : [];
          that.processProjectTileFeatures(
              tileFeatures,
              subcats,
              feature_uid_store,
              current_langID,
              layer_color,
              data,
              mapZoom,
              that,
              true,
              _year
            );
        });
        // Add layer
        this.map?.addLayer(that.projectLayer);
        // 
        this.moveEndSubscription4$?.unsubscribe();
        const moveEndObservable = fromEvent(that.map, 'moveend');
        this.moveEndSubscription4$ = moveEndObservable
          .pipe(debounceTime(200))
          .subscribe(() => {
            const zoom = this.map?.getView().getZoom();
            if(zoom < 16){that.closePopup()}
            const showProjects = zoom >= data?.minZoom;
            if (!showProjects) {
              that.removeProjectLayer(true, true);
              return;
            }
            that.removeProjectLayer(true, false);
            that.addReportLayerSafe(that.projectLayer, that);

            const extent = that.map?.getView().calculateExtent(that.map?.getSize());

            const visibleFeatures = that.projectTileFeatures?.filter(f => {
                const geomExtent = f.getGeometry().getExtent();
                return intersectsExtent(extent, geomExtent);
            });
        
            that.processProjectTileFeatures(
                    visibleFeatures,
                    subcats,
                    feature_uid_store,
                    current_langID,
                    layer_color,
                    data,
                    zoom,
                    that,
                    false,
                    _year
                  );
          });
        } else {
         let vectorTile:any = new VectorTileLayer({
              source: new VectorTileSource({
                url,
                format: new MVT(),
              }),
              minZoom: data?.minZoom,
              maxZoom: data?.maxZoom,
              zIndex: zindex,

            // vectorTileLayerStyles
            style: (feature, resolution) => {
              const properties: any = feature.getProperties();

              const labelJSON = properties?.proj_name ?? properties?.neigh_name ?? null;
              let label = "";

              if (labelJSON) {
                const parsed = JSON.parse(labelJSON);
                label = parsed[current_langID] || parsed[1] || "";
              }

              return new Style({
                stroke: new Stroke({
                  color: layer_color,
                  width: 2,
                  lineDash: [2, 6],
                }),

                fill: new Fill({
                  color: [0, 0, 0, 0],
                }),
              });
            },
          });
          that.addReportLayerSafe(vectorTile, that);
          that.Pbf_OverlayLayer[data.layer_name] = vectorTile;        
          vectorTile.getSource().on("tileloadend", (evt: any) => {
            const tile = evt.tile;
            const tileFeatures = tile.getFeatures ? tile.getFeatures() : [];
            const zoom = that.map?.getView().getZoom();
            // skip based on zoom
            if (zoom < data.minZoom || zoom > data.maxZoom) return;
            // 
            const tileUid = (tile as any).ol_uid;
            if (!that.pbfVectorTileOverlays[data.layer_name]) {
              that.pbfVectorTileOverlays[data.layer_name] = {};
            }
            // early exit BEFORE creating overlays
            if (that.pbfVectorTileOverlays[data.layer_name][tileUid]) {
              return;
            }
            // create overlays
            const overlays: Overlay[] = [];

            tileFeatures.forEach((feature: any) => {
              const props = feature.getProperties();
              if (!props) return;

              const coords = [props.lon, props.lat];

              const name = JSON.parse(props.proj_name || props.neigh_name || "{}");
              const label = name[that.current_lang_id] || name[1];

              const elm = document.createElement("div");
              elm.className = "union-orange union-blue";
              elm.innerText = label;
              elm.style.cursor = "pointer";
              elm.style.zIndex = "1000";
              elm.addEventListener("mousedown", e => e.stopPropagation());
              elm.addEventListener("pointerdown", e => e.stopPropagation());
              elm.addEventListener("touchstart", e => e.stopPropagation());
              elm.addEventListener("click", (e: MouseEvent) => {
                e.stopImmediatePropagation();
                e.preventDefault();
                that.projectPopup(e, props, that, null, true);
              });

              const overlay = new Overlay({
                element: elm,
                positioning: "center-center",
                stopEvent: false
              });

              overlay.setPosition(fromLonLat(coords));
              that.map?.addOverlay(overlay);

              overlays.push(overlay);
            });
            // store overlays
            that.pbfVectorTileOverlays[data.layer_name][tileUid] = overlays;
          });

        // handle map move events
          that.map?.on('moveend', () => {
            const zoom = that.map?.getView().getZoom();
            if (zoom < data.minZoom || zoom > data.maxZoom) {
              that.removeAllPbfVectorOverlays(true, data.layer_name, that)
            } else {
              that.addAllPbfVectorOverlays(data.layer_name, that);
            }
          });
        }
  }

  addAllPbfVectorOverlays(layerName: string, that: any = this) {
    const layer = that.Pbf_OverlayLayer[layerName];
    if (layer) that.addReportLayerSafe(layer);

    if (that.pbfVectorTileOverlays[layerName]) {
      Object.values(that.pbfVectorTileOverlays[layerName]).forEach((overlays: any) => {
        overlays.forEach((ov: Overlay) => that.map?.addOverlay(ov));
      });
    }
  }

  removeAllPbfVectorOverlays(zoomTriggered:boolean = false, layerName = "", that:any=this) {
    if (!zoomTriggered) {
      // remove all layers
      Object.values(that.Pbf_OverlayLayer).forEach(layer => {
        that.removeReportLayerSafe(layer);
      });

      // remove all overlays
      Object.values(that.pbfVectorTileOverlays).forEach((layerTiles:any) => {
        Object.values(layerTiles).forEach((overlays:any) => {
          overlays.forEach((ov:Overlay) => that.map?.removeOverlay(ov));
        });
      });

      that.pbfVectorTileOverlays = {};
      that.Pbf_OverlayLayer = {};

    } else {
      const layer = that.Pbf_OverlayLayer[layerName];
      if (layer) that.removeReportLayerSafe(layer);

      if (that.pbfVectorTileOverlays[layerName]) {
        Object.values(that.pbfVectorTileOverlays[layerName]).forEach((overlays: any) => {
          overlays.forEach((ov: Overlay) => that.map?.removeOverlay(ov));
        });
      }
    }
  }

  createLabelOverlay(feature:FeatureLike, coords:any, map:any) {
    const props:any = feature.getProperties();
    const label = props.proj_name || props.neigh_name || "";

    const el = document.createElement("div");
    el.className = "union-orange union-blue";
    el.innerText = label;

    const overlay = new Overlay({
      element: el,
      positioning: "center-center",
      stopEvent: true,
    });

    overlay.setPosition(coords);

    map.addOverlay(overlay);

    return overlay;
  }

  removeProjectLayer(onlyOverlays: boolean = false, projectLayer: boolean = false, cleanLayer: boolean = false) {
  if (this.projectLayer && projectLayer) {
    if(this.hasLayer(this.projectLayer))this.map?.removeLayer(this.projectLayer);
    if(cleanLayer) {
      this.projectLayer = null;
      this.projectTileFeatures = [];
    }
  }

  if (this.projectOverlays && this.projectOverlays?.length && onlyOverlays) {
    this.projectOverlays?.forEach(o => this.map?.removeOverlay(o));
    this.projectOverlays = [];
  }
}
processProjectTileFeatures(tileFeatures: any[],subcats: string[],feature_uid_store_a: string[],current_langID: number,
  layer_color: string, data: any, mapZoom: number, that: any , initial: boolean=false, _year: number) {
  let feature_uid_store: any = [];
  let hideTip = false;
  tileFeatures?.forEach((feature: any) => {
    if(initial)that.projectTileFeatures.push(feature);
    const properties = feature.getProperties();

    const uid = properties?.proj_uid ?? properties?.neigh_uid ?? null;
    const allowedSubcats: string[] = properties?.category?.split(',') || [];
    const hasValidSubcat =
      allowedSubcats?.length &&
      allowedSubcats?.some(cat => subcats.includes(cat.toLowerCase()));

    if ((!hasValidSubcat && subcats.length > 0) || !uid || feature_uid_store.includes(uid)) return;
    if (_year !== properties?.year) return;

    let coords;
    if (properties?.center) {
      const parsed: any = wktToGeoJSON(properties.center);
      coords = parsed.coordinates;
    } else {
      coords = [properties.lon, properties.lat];
    }

    let json_val =
      properties?.proj_name ?? properties?.neigh_name ?? null;
    if (!json_val) return;

    const parsedVal = JSON.parse(json_val);
    const label = parsedVal[current_langID] || parsedVal[1];
    let tooltip = label;

    // COLORS & CATEGORY LOGIC
    let bgColor = "#ECEAFD";
    let textColor = "#ffffff";
    let layerclass = "union-orange";
    let statusClass = "under_development";
    let tipClass = "my-labels";
    let value = `<span style='color:${layer_color};'>${label}</span>`;

    if (data?.layer_name === layerConstant.miprojects) {
      const developed = !properties.build_status?.includes("under_construction");

      statusClass = developed ? "developed" : "under_development";
      bgColor = developed ? layer_color : bgColor;
      textColor = developed ? textColor : layer_color;
      tipClass = `projets ${statusClass}`;
      layerclass = 'project_pills';

      let shape_area = properties.shape_area;
      let labelSizePX = that.estimateTextWidth(label, "9px Montserrat") + 25;
      let pixelArea = that.getApproxPixelArea(shape_area, mapZoom);
      let shapeWidth = Math.sqrt(pixelArea) + 25;
      hideTip = false;
      if (label && (labelSizePX < shapeWidth || mapZoom >= 20)) {
        hideTip = true;
        layerclass = "union-projects";
        value = `<span class='union-projects-child'
                  style='color:${textColor}; background:${bgColor}; border-color:${layer_color}'>${label}</span>`;
      } else {
        value = `<span class="${tipClass}"
                  style='background:${bgColor}; border-color:${layer_color}'></span>`
      }
    } else {
      tooltip = "";
    }

    let hoverTooltip = `<span class='union-projects-child'
                          style='color:${textColor}; background:${bgColor}; border-color:${layer_color}'>${label}</span>`;

    // Create HTML overlays
    const el = document.createElement("div");
    el.className = layerclass;
    el.innerHTML = value;
    el.style.opacity = "1";
    el.style.cursor = "pointer";

    const tooltipEl = document.createElement("div");
    tooltipEl.className = tipClass;
    tooltipEl.innerHTML = hoverTooltip;
    tooltipEl.style.opacity = "0";
    tooltipEl.style.cursor = "pointer";
    tooltipEl.style.pointerEvents = "none";

    const wrapper = document.createElement("div");
    wrapper.style.position = "relative";
    wrapper.className = "project_marker-wrapper";

    wrapper.appendChild(el);
    if(!hideTip)wrapper.appendChild(tooltipEl);

    tooltipEl.style.position = "absolute";
    tooltipEl.style.top = "-3px";
    tooltipEl.style.left = "0";
    const overlay = new Overlay({
      element: wrapper,
      positioning: "center-center",
      className: "project_marker_overlay",
      stopEvent: false
    });
    wrapper.addEventListener("mouseenter", () => {
      if(hideTip) return;
      tooltipEl.style.pointerEvents = "auto";
      tooltipEl.style.opacity = "1";
      that.hoveredProjectUid = uid;
      that.projectLayer.changed(); 
    });

    wrapper.addEventListener("mouseleave", () => {
      if(hideTip) return;
      // wrapper.style.zIndex = "0";
      tooltipEl.style.opacity = "0";
      tooltipEl.style.pointerEvents = "none";
      that.hoveredProjectUid = null;
      that.projectLayer.changed();
    });
    el.addEventListener("mouseenter", () => {
      if(!hideTip) return;
      that.hoveredProjectUid = uid;
      that.projectLayer.changed();
    });

    el.addEventListener("mouseleave", () => {
      if(!hideTip) return;
      that.hoveredProjectUid = null;
      that.projectLayer.changed();
    });

    if(hideTip){
      el.addEventListener("mousedown", e => e.stopPropagation());
      el.addEventListener("pointerdown", e => e.stopPropagation());
      el.addEventListener("touchstart", e => e.stopPropagation());

        el.addEventListener("click", (evt: MouseEvent) => {
          evt.stopPropagation();
          evt.preventDefault();
          const cords = fromLonLat([properties.lon, properties.lat]);
            that.projectPopup(evt, properties, that, cords)
        })
    } else {
      tooltipEl.addEventListener("mousedown", e => e.stopPropagation());
      tooltipEl.addEventListener("pointerdown", e => e.stopPropagation());
      tooltipEl.addEventListener("touchstart", e => e.stopPropagation());

      tooltipEl.addEventListener("click", (evt: MouseEvent) => {
        evt.stopPropagation();
          evt.preventDefault();
        const cords = fromLonLat([properties.lon, properties.lat]);
            that.projectPopup(evt, properties, that, cords)
        })
    }
    overlay.setPosition(fromLonLat(coords));
    that.map?.addOverlay(overlay);
    that.projectOverlays.push(overlay);

    feature_uid_store.push(uid);
  });
}

projectPopup(evt: MouseEvent, properties: any, that: any = this, cords: any = null, isneighbourhood: boolean = false) {
  that.mapWidth = that.mapIdentifier.nativeElement.offsetWidth;
  that.mapHeight = that.mapIdentifier.nativeElement.offsetHeight;
  const rect = that.map?.getTargetElement().getBoundingClientRect();
  const pixel = [
    evt.clientX - rect.left,
    evt.clientY - rect.top
  ];
  const clickedPixel = cords? cords : that.map?.getCoordinateFromPixel(pixel);
  let options = that.mapService.popupOptions(pixel, that.mapWidth, that.mapHeight);
  let btn_label = isneighbourhood?"Neighbourhoods":"Project";
  const content = that.mapService.popup_content('project', properties, that.currentReportData?.allowed_attributes, btn_label, '', '');
  that.OpenCustomPop(content, clickedPixel, options.class_name, true)

}

  
private textCanvas: HTMLCanvasElement = document.createElement("canvas");
private textContext: CanvasRenderingContext2D = this.textCanvas.getContext("2d", { willReadFrequently: true })!;

  estimateTextWidth(text: string, font: string = "9px Arial") {
    // const canvas = document.createElement("canvas");
    // let context: CanvasRenderingContext2D = canvas.getContext("2d", { willReadFrequently: true }) as CanvasRenderingContext2D;
    this.textContext.font = font;
    return this.textContext.measureText(text).width;
  }
  getApproxPixelArea(shapeArea: number, zoom: number): number {
    const metersPerPixel = 156543.03392 / Math.pow(2, zoom);
    return shapeArea / (metersPerPixel * metersPerPixel);
  }
  mapLegendmenu() {
    let that = this;
    let zoningData:any = that.currentReportDataLegends.find((r: any) => r.legend_type == layerConstant.zoning) || {};
    let categoryData:any = that.currentReportDataLegends.find((r: any) => r.legend_type == layerConstant.category) || {};
    that.legend_data = that.layerData?.legend.filter((r: any) => r.display == true);
    const categoryColorObject = categoryData?.data?.reduce((acc: any, item: any) => {
        item.category.forEach((cat: any) => {
          const splitCategories = cat.split(',').map((c: string) => c.trim());
          splitCategories.forEach((singleCategory: any) => {
            acc[singleCategory] = item.color;
          });
        });
        return acc;
      }, {});
      if (categoryColorObject) {
        this.sharedService.setStoreValue(GlobalContants.StoreKey.legend, categoryColorObject);
      }
      const zoningColorObject = zoningData?.data?.reduce((acc: any, item: any) => {
        item.category.forEach((cat: any) => {
          const splitCategories = cat.split(',').map((c: string) => c.trim());
          splitCategories.forEach((singleCategory: any) => {
            acc[singleCategory] = item.color;
          });
        });
        return acc;
      }, {});
      if (zoningColorObject) {
        this.sharedService.setStoreValue(GlobalContants.StoreKey.zoning, zoningColorObject);
      }
    // this.currentLegendView$?.unsubscribe();
    if(!this.currentLegendView$) {
    this.currentLegendView$ = this.mapService.legendLayerGroupList.pipe(
      distinctUntilChanged()
    ).subscribe((data: any) => {
      if (data) {
        let legendData = this.mapService.filterLegendData(data)
        this.legend_data_by_group = legendData.filter((item: any) => item.display == true && item.status == true);
      } else {
        let lagendActiveGroupData = this.mapService.filterLegendData(this.currentReportData?.legend);
        this.legend_data_by_group = lagendActiveGroupData?.filter((item: any) => item.display == true && item.status == true);
      }
      let activeLayer = this.mapLayers?.find((item: any) => item.display && item.layer_name == layerConstant.miprojects);
      if(activeLayer || this.projectLayer_pbf?.length){
        this.legend_data_by_group = [...layerConstant.miprojects_labels, ...this.legend_data_by_group];
      }
      if (this.activatedRoute.snapshot.queryParams['polygon']) this.refreshPolygoncount('polygon')
    });
  }

    that.mapService.legendToggle.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((toggle: boolean) => {
      that.legendToggle = toggle;
      if(toggle) {
        that.mapPanStopCondition('.legendContainerMap');
      }
      that.mapLayerZoomlimit(false);
    })
  }

  collapseLegend() {
    this.mapPanStopCondition('.legendContainerMap', true);
    this.mapService.legendToggle.next(false);
  }

  propertyInfo(properties: any) {
    this.reportService.transactionPropertyDetails.next(properties);
    this.selected_property = properties;
    if (this.selected_property?.proj_uid) this.propertyUid = this.selected_property?.proj_uid;
  }

  returnVal(value: string, type: string, mainobj: any) {
    if (type == 'text') {
      return this.translate.instant(value.replace(/_/g, " ").toLowerCase());
    } else if (type == 'src') {
      let style_name;
      let place_id = this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceId);
      let store_name = this.layerData.store_name;
      let layer_name = `${this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode)}_${this.layerData.layer_name}_${this.layer_year}`;
      let style_index = this.legend_data.findIndex((r: any) => r == mainobj);
      if (style_index == 0) {
        if (mainobj.type != 'like') style_name = `style_Layer_${mainobj.type}`;
        else style_name = `style_Layer_${mainobj.legend}`;
      } else if (style_index == 1) {
        if (mainobj.type != 'like') style_name = `style_Layer2_${mainobj.type}`;
        else style_name = `style_Layer2_${mainobj.legend}`;
      } else if (style_index == 2) {
        if (mainobj.type != 'like') style_name = `style_Layer1_${mainobj.type}`;
        else style_name = `style_Layer1_${mainobj.legend}`;
      }
      let url = `${environment.geoestater}wms-layer?place_id=${place_id}&token=${environment.user_token}&request=GetLegendGraphic&layer=${layer_name}` +
        `&style=${style_name}&width=20&height=20&store=${store_name}&rule=${value}`;
      return url;
    } else {
      return value;
    }
  }

  mapFullScreen() {
    let that = this;
    that.mapService.mapFullscreenToggle.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((fullScreen: any) => {
      if (fullScreen)
        that.map?.toggleFullscreen()
    });
  }

  toggle_LayerFilter() {
    this.resetFilterSub$?.unsubscribe();
    this.resetFilterSub$ = this.mapService.reportFiltertoggle.subscribe({
      next: (data) => this.layerFilter(data),
      complete: () => this.refreshPolygoncount()
    });
  }

  layerFilter(type: any = '') {}

  pbf_LayerFilter(pbf_filter: any) {}

  pbf_Condition(pbf_filter: any, properties: any) {
    let condition: any;
    let result_val: any = [];
    pbf_filter.forEach((filter: any) => {

      if (filter.type == 'equals') {
        condition = filter.value.split(',').map((s: any) => {
          if (properties[filter.parameter]) {
            let fmName = properties[filter.parameter].toString();
            if (fmName.toLowerCase() == s.toString()) {
              result_val.push(true);
            }
          }
        });
      }
      if (filter.type == 'number') {
        condition = `${properties[filter.parameter]} > ${filter.value.split('-')[0]} && ${properties[filter.parameter]} < ${filter.value.split('-')[1]}`;
        if (condition) result_val.push(true);
      }
      if (filter.type == 'like') {
        let val_label = properties[filter.parameter];
        if (val_label) {
          condition = `${filter.value.split(',').map((s: any) => `val_label.includes('${s}')`).join(' || ')}`;
          if (eval(condition))
            result_val.push(true);
        } else
          result_val.push(true)
      }
      if (filter.type == 'date') {
        let val_label = properties[filter.parameter];
        if (val_label) {
          condition = Date.parse(val_label) >= Date.parse(filter.value[0]) && Date.parse(val_label) <= Date.parse(filter.value[1]);
          if (eval(condition))
            result_val.push(true);
        } else
          result_val.push(true)
      }
    })

    if (pbf_filter.length < 1) {
      return true;
    } else if (result_val.length == pbf_filter.length) {
      return result_val.includes(true);
    } else {
      return false;
    }
  }
  /**
   * createTransactionLegend create transaction legend based on whether the report is a transaction report or not.
   * @param isTransaction
   */

  createTransactionLegend(isTransaction: boolean, lumpsum:any=null): void {
  const currencyCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode);
  const currencySymbol = `${this.translate.instant(currencyCode)}/${this.translate.instant(GlobalContants.keySymbolContants.squareMeterUnit)}`;

  if (this.is_transaction_table) {
    this.clusterInfoList = [
      {
        name: this.translate.instant('reports.property_transaction_rate'),
        symbol: currencySymbol,
        img: 'assets/images/property-transaction-rate.svg',
        count: false
      },
      {
        name: this.translate.instant('reports.unitTransactionRate'),
        symbol: currencySymbol,
        img: 'assets/images/unit-transaction-rate.svg',
        count: false
      }
    ];
  } else if (this.is_rental_table) {
    this.clusterInfoList = [
      {
        name: this.translate.instant('reports.unitRentRate'),
        symbol: currencySymbol,
        img: 'assets/images/unit-transaction-rate.svg',
        count: false
      }
    ];
    if(lumpsum && lumpsum?.value != layerConstant.rentalClusters[0].value && lumpsum?.label) {
      this.clusterInfoList[0].name = lumpsum.label[this.current_lang_id] || lumpsum.label[1];
      if(lumpsum.value == layerConstant.rentalClusters[2].value){
        this.clusterInfoList[0].symbol = currencyCode;
      }
    } else if(lumpsum && lumpsum.value == layerConstant.rentalClusters[0].value) {
      this.clusterInfoList = [];
    }
  } else {
    this.clusterInfoList = [
      {
        count: true,
        color: '#3774E8',
        name: this.translate.instant('Property Count')
      }
    ];
  }
  this.reportService.clusterInfoData.set(this.clusterInfoList);
}
/**\
 * legendCount update legend count based on the active layers on the map
 */
legendCount() {
  const clusterData = this.reportService.clusterInfoData(); // Get cluster data
    const mapLayerData = this.reportService.mapLayerData(); // Get map layer data (Attribuits layers)
    this.legend_data_by_group  = this.reportService.mapLayerDataCat(); // Get legend data based on active layers
      if(clusterData?.length > 0) {
      this.layerselected = this.legend_data_by_group?.length +1;
      } else {
        this.layerselected = this.legend_data_by_group?.length;
      }
  }

  /**
   * count cluster
   * @param data 
   * @param is_avg_transaction 
   * @param rent_multiplier 
   */
  
 createClusterIconCount(item: any, unit:number=0, building:number=0): string {
  const height = 24;               
  const minWidth = 24;             
  const extraWidthPerDigit = 5;    
  let count = this._decimalPipe.transform(item, '1.0-0') || '0'
  const width = Math.max(minWidth, minWidth + (count.length - 1) * extraWidthPerDigit);
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
      <rect x="0" y="0" width="${width}" height="${height}" rx="13" ry="13" fill="#3774E8"/>
      <text x="50%" y="50%" text-anchor="middle" dy=".35em" font-size="10" fill="#fff" font-family="Manrope, Arial, sans-serif">${count}</text>
    </svg>
  `;
  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
}
/**
 * rental and transactions map cluster 
 * @param unit_transaction_rate 
 * @param property_transaction_rate 
 * @returns 
 */
createClusterIcon(unit_transaction_rate?: number, property_transaction_rate?: number, unit_name:string='', width_unitname:number=0): string {
  const padding = 2;
  const iconSize = 8;
  const rowHeight = 18;
  const textPadding = 4;
   const count2 = (unit_transaction_rate && unit_transaction_rate >= 1) ? this.mapService.formatInternationNumNoDismal(unit_transaction_rate) : unit_transaction_rate ? this._decimalPipe.transform(unit_transaction_rate, '1.0-1'):null;
   const count1 = property_transaction_rate = (property_transaction_rate && property_transaction_rate >= 1) ? this.mapService.formatInternationNumNoDismal(property_transaction_rate) : property_transaction_rate?this._decimalPipe.transform(property_transaction_rate, '1.0-1'):null;
  const hasTwoRows = !!(count1 && count1 != '0' && count2 && count2 != '0');

  // Width based on max text
  const maxCountLength = Math.max(count1?.length || 0, count2?.length || 0);
  const width = iconSize + textPadding + (unit_name ? unit_name.length + maxCountLength : maxCountLength) * 5.5 + 10;

  const unitIconSVG = `
    <svg x="${padding}" y="0" width="${iconSize}" height="${iconSize}" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 0H1C0.45 0 0 0.45 0 1V9C0 9.55 0.45 10 1 10H9C9.55 10 10 9.55 10 9V1C10 0.45 9.55 0 9 0ZM3 9H1.5C1.225 9 1 8.775 1 8.5V7H3V9ZM3 6H1V4H3V6ZM3 3H1V1.5C1 1.225 1.225 1 1.5 1H3V3ZM6 9H4V7H6V9ZM6 6H4V4H6V6ZM6 3H4V1H6V3ZM8.5 9H7V7H9V8.5C9 8.775 8.775 9 8.5 9ZM9 6H7V4H9V6ZM9 3H7V1H8.5C8.775 1 9 1.225 9 1.5V3Z" fill="white"/>
    </svg>
  `;

  const buildingIconSVG = `
    <svg x="${padding}" y="0" width="9" height="9" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_32792_49590)">
    <path d="M4.00068 0.666504H2.00055C1.17317 0.666504 1.00049 0.839181 1.00049 1.66657V7.33359H5.00074V1.66657C5.00074 0.839181 4.82806 0.666504 4.00068 0.666504Z" stroke="white" stroke-width="0.7" stroke-linejoin="round"/>
    <path d="M6.00104 2.6665H5.00098V7.33346H7.0011V3.66657C7.0011 2.83918 6.82842 2.6665 6.00104 2.6665Z" stroke="white" stroke-width="0.7" stroke-linejoin="round"/>
    <path d="M2.66748 1.99951L3.33419 1.99951M2.66748 2.99957L3.33419 2.99957M2.66748 3.99964L3.33419 3.99964" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.83474 7.33313V5.99972C3.83474 5.68543 3.83474 5.52828 3.7371 5.43065C3.63947 5.33301 3.48232 5.33301 3.16803 5.33301H2.83468C2.52039 5.33301 2.36324 5.33301 2.26561 5.43065C2.16797 5.52828 2.16797 5.68543 2.16797 5.99972V7.33313" stroke="white" stroke-width="0.7" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_32792_49590">
    <rect width="9" height="9" fill="white"/>
    </clipPath>
    </defs>
    </svg>
  `;

  let height =  (rowHeight * (hasTwoRows ? 2 : 1));
  if(hasTwoRows) height = (height - 3);

  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg"
         width="${width}" height="${height}"
         style="cursor:pointer">
      
      <rect x="0" y="0"
            width="${width}" height="${height}"
            rx="6" ry="6"
            fill="#3774E8"/>

      ${count1 ? `
        <g transform="translate(${padding}, ${ rowHeight/2 - iconSize/2})">
          ${buildingIconSVG}
          <text x="${iconSize + textPadding + 2}"
                y="${iconSize / 2}" dy=".35em"
                font-size="10" fill="#fff"
                font-family="Manrope, Arial, sans-serif">${count1}</text>
        </g>
      ` : ''}

      ${count2 ? `
        <g transform="translate(${padding}, ${
          hasTwoRows
            ? (rowHeight + rowHeight/2 - 7)
            : (rowHeight/2 - iconSize/2)
        })">
          ${!unit_name ? unitIconSVG : ''}
          <text x="${unit_name ? textPadding + 2 : (iconSize + textPadding + 2)}"
                y="${hasTwoRows ? 5 : iconSize/2}"
                dy=".35em"
                font-size="10" fill="#fff"
                font-family="Manrope, Arial, sans-serif">${unit_name ? unit_name : ''} ${count2}</text>
        </g>
      ` : ''}
    </svg>
  `;
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
}

  async reportCountLayer(data: any, is_avg_transaction: boolean = false, rent_multiplier:any = null) {
    let isTransaction = !!(is_avg_transaction || this.is_avg_transaction);
    let is_avg_rental = false;
    let lumsum=null;
    if(this.is_rental_table){
      lumsum = this.isLumSum
    } 
      
    let that = this;

    await that.removelastcouster(true);
    this.createTransactionLegend(isTransaction, lumsum);
    setTimeout(() => that.clusterLayerFunction(data, is_avg_transaction, rent_multiplier), 20);
  }
  /**
   * Reusable function for cluster layer
   * @param data 
   * @param is_avg_transaction 
   * @param rent_multiplier 
   */
  clusterLayerFunction(data: any, is_avg_transaction: boolean = false, rent_multiplier: any = null) {
    let that = this;
    let is_avg_rental = false;
    let lumsum = null;
    if (this.is_rental_table) {
      lumsum = this.isLumSum
    }
    // console.log(is_avg_transaction, rent_multiplier, that.isLumSum.isLumsum)
    if (data && data.length >= 1) {
      if (is_avg_transaction) that.is_avg_transaction = is_avg_transaction;

      let features = [];
      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        let is_avg_rental = item?.is_avg_rental || false;
        let property_transaction_rate = 0, unit_transaction_rate = 0;
        if (is_avg_transaction || is_avg_rental) {
          if ((!item.property_transaction_value || item.property_transaction_value === 0) &&
            (!item.unit_transaction_value || item.unit_transaction_value === 0)
          ) {
            continue;
          }
          property_transaction_rate = (item.property_transaction_value && !that.isLumSum.isLumsum)
            ? item.property_transaction_value / item.property_transaction_area
            : (item.property_transaction_value && that.isLumSum.isLumsum) ? item.property_transaction_value / item.count : 0;
          unit_transaction_rate = (item.unit_transaction_value && !that.isLumSum.isLumsum)
            ? item.unit_transaction_value / item.unit_transaction_area
            : (item.unit_transaction_value && that.isLumSum.isLumsum) ? item.unit_transaction_value / item.count : 0;
          if (rent_multiplier && is_avg_rental) unit_transaction_rate = (unit_transaction_rate * (+rent_multiplier));
        }

        const feature = new Feature({
          geometry: new Point(fromLonLat([item.lon, item.lat])),
          customData: item,
          count: item.count,
          property_transaction_rate: property_transaction_rate,
          unit_transaction_rate: unit_transaction_rate,
          property_transaction_value: item.property_transaction_value,
          property_transaction_area: item.property_transaction_area,
          unit_transaction_value: item.unit_transaction_value,
          unit_transaction_area: item.unit_transaction_area,
          is_avg_rental: item.is_avg_rental || is_avg_rental,
        });
        features.push(feature);
      };
      const source = new VectorSource({
        features: features
      });
      const clusterSource = new Cluster({
        distance: 50,
        minDistance: 30,
        source: source
      });

      const styleCache: Record<any, Style> = {};
      const clusterLayer = new VectorLayer({
        source: clusterSource,
        style: (feature) => {
          const clusteredFeatures: Feature[] = feature.get('features');
          const size = clusteredFeatures
            .map(f => {
              const unitVal = f.get("unit_transaction_value") ?? 0;
              const propVal = f.get("property_transaction_value") ?? 0;
              const count = f.get("count") ?? 0;

              return `${unitVal || count}-${propVal}`;
            })
            .join("|");
          if (!styleCache[size] && is_avg_transaction) {
            let totalUnitValue = 0;
            let totalUnitArea = 0;

            let totalPropValue = 0;
            let totalPropArea = 0;

            clusteredFeatures.forEach(f => {

              totalUnitValue += Number(f.get('unit_transaction_value') || 0);
              totalUnitArea += Number(f.get('unit_transaction_area') || 0);

              totalPropValue += Number(f.get('property_transaction_value') || 0);
              totalPropArea += Number(f.get('property_transaction_area') || 0);
            });
            let sumCount = 0;
            if (that.isLumSum.isLumsum) {
              sumCount = clusteredFeatures.reduce((sum, f) => {
                return sum + Number(f.get('count') || 0);
              }, 0);
            }
            const anyFeature = clusteredFeatures[0];
            const isAvgRentalFeature = !!anyFeature.get("is_avg_rental");
            let unit_transaction_rate =
              (totalUnitValue && !that.isLumSum.isLumsum) ? totalUnitValue / totalUnitArea : (totalUnitValue && that.isLumSum.isLumsum) ? totalUnitValue / sumCount : 0;
            if (rent_multiplier && isAvgRentalFeature) unit_transaction_rate = (unit_transaction_rate * (+rent_multiplier));
            const property_transaction_rate =
              (totalPropValue && !that.isLumSum.isLumsum) ? totalPropValue / totalPropArea : (totalPropValue && that.isLumSum.isLumsum) ? totalPropValue / sumCount : 0;
            // console.log(unit_transaction_rate, property_transaction_rate)
            styleCache[size] = new Style({
              image: new Icon({
                src: that.createClusterIcon(unit_transaction_rate, property_transaction_rate),
                scale: 1
              })
            });
          } else if (!styleCache[size] && !is_avg_transaction) {
            const sumCount = clusteredFeatures.reduce((sum, f) => {
              return sum + Number(f.get('count') || 0);
            }, 0);
            styleCache[size] = new Style({
              image: new Icon({
                src: that.createClusterIconCount(sumCount),
                scale: 1
              })
            });
          }

          return styleCache[size];
        }
      });
      clusterLayer.setZIndex(18);
      that.report_countLayer = clusterLayer;
      if(this.mapZoom < 16) that.addReportLayerSafe(that.report_countLayer);
      that.map?.on('click', (evt: MapBrowserEvent) => {
        const clicked: Feature<Geometry>[] | undefined = that.map?.getFeaturesAtPixel(evt.pixel);
        if (!clicked || !clicked.length) return;

        const clusterFeature = clicked[0];
        const features: Feature<Geometry>[] | undefined = clusterFeature.get('features');
        if (!features || !features.length) return;

        if (features.length < 3) {
          const geom = features[0].getGeometry();
          if (geom instanceof Point) {
            const coords = geom.getCoordinates();
            that.map?.getView().animate({
              center: coords,
              zoom: 16,
              duration: 800
            });
          }
          return;
        }

        const coords: number[][] = features
          .map((f: Feature<Geometry>) => f.getGeometry())
          .filter((geom: Geometry | undefined): geom is Point => geom instanceof Point)
          .map((point: Point) => point.getCoordinates());

        if (!coords.length) return;

        const extent = boundingExtent(coords);

        that.map?.getView().fit(extent, {
          duration: 800,
          padding: [50, 50, 50, 50]
        });
      });
      that.moveEndSubscription1$?.unsubscribe();
      that.moveEndSubscription1$ = fromEvent(that.map, 'moveend')
        .pipe(debounceTime(100))
        .subscribe(() => {
          if (!that.isClusterActive) return;
            if (that.map?.getView().getZoom() >= 16) {
              that.removeReportLayerSafe(that.report_countLayer, that);
            } else {
              if (that.report_countLayer) that.addReportLayerSafe(that.report_countLayer, that);
            }
          that.mapLayerZoomlimit(true);
          this.map?.updateSize();
          this.map_spinner = true;
        });
    }
  }
/**
 * check layer is present on map or not
 * @param layer 
 * @returns boolean
 */
hasLayer(layer: any, map:any='') {
  if(!map) map=this.map;
  if (!map || !layer) return null;

  const uid = layer.ol_uid; 
if(!uid) return false;
let x = map
    .getLayers()
    .getArray()
    .find((l: any) => l.ol_uid === uid);
  return x
}

/**
 * add layer safly 
 * @param layer 
 * @param that 
 * @returns 
 */

 addReportLayerSafe(layer: VectorLayer, that:any=this) {
  if (!layer) return;
  if (!that.hasLayer(layer)) {
    that.map?.addLayer(layer);
  }
}
/**
 * 
 * @param layer Remove Layer Safly 
 * @param that 
 * @returns 
 */
 removeReportLayerSafe(layer: VectorLayer, that:any=this) {
  if (!layer) return;
  let layer_uid = that.hasLayer( layer, that.map)
  if (layer_uid) {
    that.map?.removeLayer(layer_uid); 
  }
}

  drawPolygon(type?: any) {
    this.loadCatchmentShow = false;
    this.reLoadCatchmentShow = false;
    this.drawCatchmentControl =true;
    this.polygon_create = true;
  }

  refreshPolygoncount(catchment = '', toggle:boolean = false) { }
  async removelastcouster(flag: boolean = false) {
    let that = this;
    that.removeReportLayerSafe(that.catchment_Markers, that);
    if (this.catchment_Markers) {
      this.catchment_Markers.remove();
      this.catchment_Markers = null;
      this.catchmentData = [];
    }
    if (!this.isClusterActive) that.removeReportLayerSafe(that.report_countLayer, that);
    if (this.report_countLayer && flag) {
      that.removeReportLayerSafe(that.report_countLayer, that);
      this.report_countLayer = null;
    }
  }
  multipolgonReportCount(layer: any, count: any, type: string = '', toggle: boolean = false) {}


  catchmentExpand(value: any) {
    this.isCatchmentExpand = value;
  }

  resetCatchmentConfirm(clearFlter: any = null) {
    this.drawSource.clear()
    this.drawnPolygons = [];
    this.usedColors=[];
    this.availableColors = [...this.colors];
    this.availableColorClasses = [...this.colorsClass];
    
    this.polygon_WKT = null;
    this.polygon_chip = false;
    this.polygon_create = false;
    this.drawCatchmentControl =false;
    this.mapService.drawPolyToggle.next(this.polygon_create);
    this.cancelDrawing();
    if (clearFlter) {
      this.sharedService.clearSession('filter');
    }

    // Remove polygon query params
    this.router.navigate([], {
      queryParams: {
        'polygon': null,
        'centroid': null,
        'youCanRemoveMultiple': null,
      },
      queryParamsHandling: 'merge'
    })
  }

  closeChip(event: any, search: boolean = false) {
    if (search) {
      this.isOpenMapSearch = true;
    }
    this.Searched_properties = null;
    this.isShowChip = false;
    this.showUniversalSearch();
  }


  preventScrollPropagation(event: WheelEvent) {
    event.stopPropagation();
  }
  removeScrollPropagationEvent() {
    if (this.searchOverlayDiv && this.mouseEnterHandler) {
      this.searchOverlayDiv.removeEventListener('mouseenter', this.mouseEnterHandler);
    }
    if (this.searchOverlayDiv && this.mouseEnterHandlerRemove) {
      this.searchOverlayDiv.removeEventListener('mouseleave', this.mouseEnterHandlerRemove);
      // this.map.dragging?.enable();
    }
    if (this.searchOverlayDiv) {
      this.searchOverlayDiv.removeEventListener('wheel', this.preventScrollPropagation);
      this.searchOverlayDiv.removeEventListener('dblclick', this.preventScrollPropagation);
    }
  }
  
  openMapSearch() {
    this.isShowChip = false;
    this.mapLayertoggle = false;
    this.isOpenMapSearch = !this.isOpenMapSearch
    this.cdr.detectChanges();
    this.searchOverlayDiv = document.querySelector('.search_container');

  }
  layerToggle() {
    this.isOpenMapSearch = false;
    this.mapLayertoggle = !this.mapLayertoggle;
    this.mapService.mapFiltertoggle.next(false);
    this.mapService.mapLayertoggle.next(true);
    this.searchOverlayDiv = document.querySelector('.mapLayer__panel');
    
  }
  /**
   * disable/enable map panning interaction
   */
  disableEnableDragging(flag: boolean){ 
    this.map?.getInteractions().forEach((interaction: Interaction) => {
      if (interaction instanceof DragPan) {
        interaction.setActive(flag);
      }
    });
  }
  /**
   * Enable map panning interaction
   */
  // enableDragging(){
  //   this.map?.getInteractions().forEach((interaction: Interaction) => {
  //     if (interaction instanceof DragPan) {
  //       interaction.setActive(true);
  //     }
  //   });
  // }
  async locateSearchedParcelOnMap(properties: any) {
    this.isShowChip = true;
    this.isOpenMapSearch = false
    // this.showRecentSearch = true;
    // this.removeScrollPropagationEvent();
    this.reportService.transactionPropertyDetails.next(false);
    this.Searched_properties = properties;
   
    if (this.universalSearchMarker)
      this.removeOLMarker(this.universalSearchMarker);

    let content: any;
    this.mapWidth = this.mapIdentifier.nativeElement.offsetWidth;
    this.mapHeight = this.mapIdentifier.nativeElement.offsetHeight;
    let that = this;
    try {
      const propertyData: any = await that.mapService.getParcelInfo(properties?.property_uid);
      if (propertyData.status == 200 && propertyData?.data?.length) {
        properties = propertyData.data[0];
          if (that.currentReportData && that.currentReportData?.name.includes('transaction')) {
          content = that.mapService.popup_content('transaction', properties, that.currentReportData?.allowed_attributes, '', '')
          that.popupContentuniversal = { type: 'transaction', propertiesdata: properties, allowedAttributes: that.currentReportData?.allowed_attributes }
        } else {
          content = that.mapService.popup_content('property', properties, that.currentReportData?.allowed_attributes, '', '');
          that.popupContentuniversal = { type: 'property', propertiesdata: properties, allowedAttributes: that.currentReportData?.allowed_attributes }
        }
        setTimeout(() => {
          this.panToOLMap(properties.lat, properties.lon, 17);
        }, 50)
        this.universalSearchMarker = this.addImageMarker(properties.lat, properties.lon, '../../../../assets/images/location.svg', 1, content, properties);
      
        setTimeout(() => {
          this.OpenCustomPop(content, fromLonLat([properties.lon, properties.lat]), 'topCenter')
        }, 500);
      } else {
        console.error("No Data");
      }
    } catch (error) {
      console.error("Failed to fetch property data:", error);
    }
  }

  showUniversalSearch() {
    this.reportService.transactionPropertyDetails.next(false);
    if (this.universalSearchPopUp)
      this.universalSearchPopUp.remove();
    this.closePopup();
    if (this.universalSearchMarker)
      this.removeOLMarker(this.universalSearchMarker);
  }


  loadCatchment() {
    this.loadCatchmentShow = true;
    //// ?this.map?.doubleClickZoom.disable();
    //// ?this.map?.dragging.disable();
  }

  closeLoadCatchment(event: any) {
    this.loadCatchmentShow = false;
    this.reLoadCatchmentShow = false
    ////? this.map?.doubleClickZoom.enable();
    ////?this.map?.dragging.enable();
  }

  loadCatchmentModel() {
    this.resetCatchmentConfirm('clear')
    this.reLoadCatchmentShow = true;
    this.loadCatchmentShow = true;
    //// ? this.map?.doubleClickZoom.disable();
    //// ? this.map?.dragging.disable();
  }

  getSavedCatchment(event: any = '') {
    this.reportService.savedFilterList(event).subscribe((data: any) => {
      if (data.data.length) {
        this.savedCatchment = data.data;
        this.reportService.savedCatchmentList = data.data;
      } else {
        this.savedCatchment = [];
        this.reportService.savedCatchmentList = [];
      }
    });
  }

  drawNewCatchmentLoad() {
    this.resetCatchmentConfirm('clear')
    setTimeout(() => {
      this.drawPolygon()
      this.map?.removeLayer(this.report_countLayer);
      this.mapService.getReportCount(null, this.isLumSum.isLumsum).subscribe((layerdata: any) => {
        let data = layerdata.data;
        this.reportCountLayer(data, layerdata?.is_avg_transaction, data?.rent_multiplier);
      })
    }, 0)
  }

  /**
 * checkPolygonDraw function to referesh/check polygon
 */
  checkPolygonDraw(isRateControl:boolean=false) {
    // return;
    // let that = this;
    if (this.activatedRoute.snapshot.queryParams['polygon']) {
      if (!this.polygon_create) {
        this.polygon_create = true;
        this.drawSource.clear();
        const shapes = JSON.parse(this.activatedRoute.snapshot.queryParams['polygon']);
        this.drawnPolygons = shapes.features;
        this.polygon_WKT = shapes;

        const format = new GeoJSON();
        const features = format.readFeatures(shapes, {
          featureProjection: "EPSG:3857",
        });

        features.forEach((f, i) => {
          const original = shapes.features[i];
          const color = original.color;
          const area = original.area;
          const catchmentType = original?.catchmentType;
          // 
          if(!catchmentType) {
            const geom = f.getGeometry();
            if (!(geom instanceof Polygon)) return;
            const coords = geom.getCoordinates()[0];
            if (coords.length < 20) return;
            const extent = geom.getExtent();
            const center = [
              (extent[0] + extent[2]) / 2,
              (extent[1] + extent[3]) / 2
            ];
            const distances = coords.map(c => {
              return Math.sqrt(
                Math.pow(c[0] - center[0], 2) +
                Math.pow(c[1] - center[1], 2)
              );
            });

            const avgRadius =
              distances.reduce((a, b) => a + b, 0) / distances.length;

            // Check variation tolerance (very important)
            const tolerance = avgRadius * 0.02; // 2% tolerance

            const isCircle = distances.every(d =>
              Math.abs(d - avgRadius) < tolerance
            );

            if (!isCircle) return;
            const circle = new Circle(center, avgRadius);
            f.set('catchmentType', 'Circle');
            f.setGeometry(circle);
          }

          // 
          if(catchmentType == 'Circle'){
            const center4326 = original.center;
              const center3857 = transform(center4326, 'EPSG:4326', 'EPSG:3857');
              const radius = original.radius;
              const circle = new Circle(center3857, radius);
              f.setGeometry(circle);
          }
          if(this.usedColors.findIndex(e=>e.color == color) == -1){
            this.usedColors.push({
              id: original.id_,
              color: color,
              area: area,
              className: original.colorClassName,
              catchmentType: catchmentType
            });
          }
          f.set('color_class_name', original.colorClassName);
          f.set('color', color);
          f.set('area', area);
          f.set('catchmentType', catchmentType);
          f.setId(original.id_);
          f.changed();
        });

        this.usedColors.forEach(u => {
          let idx1 = this.availableColors.indexOf(u.color);
          if (idx1 !== -1) this.availableColors.splice(idx1, 1);

          let idx2 = this.availableColorClasses.indexOf(u.className);
          if (idx2 !== -1) this.availableColorClasses.splice(idx2, 1);
        });
     
        if (this.drawSource && this.drawSource.addFeatures) {
          this.drawSource.addFeatures(features);
        } else {
          console.error("drawSource is not a VectorSource");
        }
      }
      let layer = this.activatedRoute.snapshot.queryParams['polygon'];
      this.cancelMapApi$.next();
      this.count_LayerSub$ = this.mapService.getReportCount(layer, this.isLumSum.isLumsum)
      .pipe(takeUntil(this.cancelMapApi$)).subscribe((layerdata: any) => {
        let data = layerdata.data;
        this.reportCountLayer(data, layerdata?.is_avg_transaction, layerdata?.rent_multiplier);
      })
      
      const geojson = JSON.parse(this.activatedRoute.snapshot.queryParams['polygon']);
      const lege = GlobalContants.StoreKey.legend;
      let legend = this.sharedService.getStoreValue(lege);
      let that=this;
      if (that.layer1) that.removeReportLayerSafe(that.layer1);
      if (that.layer2) that.removeReportLayerSafe(that.layer2);
      if (that.layer3) that.removeReportLayerSafe(that.layer3);
      if (that.layer4) that.removeReportLayerSafe(that.layer4);
      this.layer1 = null;
      this.layer2 = null;
      this.layer3 = null;
      this.layer4 = null;
      this.cancelMapApiCH$.next();
      geojson.features.forEach((feature: any, i: number) => {

        const geometry = feature.geometry;
        if (feature.geometry?.type !== 'Polygon') {
          return; // skip non-polygons
        }
        const coords = geometry.coordinates[0]; // outer ring

        const wktCoords = coords
          .map((c: number[]) => `${c[0]} ${c[1]}`) // lon lat
          .join(', ');
        
          const wkt = `POLYGON((${wktCoords}))`;
          this.getJsonData(String(i+1), wkt, legend, '',null);

        })
      
       if(!isRateControl)this.fitPolygonOnMap();

    } else {
      this.polygon_create = false;
      this.drawCatchmentControl = false;
      this.polygon_WKT = null;
      this.drawnPolygons = [];

      // if (that.editableLayers) that.editableLayers.remove();
      if (this.catchment_Markers) this.catchment_Markers.remove();
      /// set zoom and center from the URL
      this.map?.getView().setZoom(12);
      if (this.activatedRoute.snapshot.queryParams['zoom']) {
        this.mapService.setZoom(Number(this.activatedRoute.snapshot.queryParams['zoom']))
        this.mapZoom = Number(this.activatedRoute.snapshot.queryParams['zoom']);
        if (!this.activatedRoute.snapshot.queryParams['amenities']) this.map?.getView().setZoom(this.mapZoom);
      }
      if (this.activatedRoute.snapshot.queryParams['centroid'] && this.map) {
        const centroidParam = this.activatedRoute.snapshot.queryParams['centroid'];
        const parts = String(centroidParam).split('-').map((v: any) => Number(v));
        if (parts.length >= 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
          const lat = parts[0];
          const lon = parts[1];
          // Set OL view center and zoom
          try {
            this.map?.getView().setCenter(fromLonLat([lon, lat]));
            const z = Number(this.activatedRoute.snapshot.queryParams['zoom']);
            if (!isNaN(z)) this.map?.getView().setZoom(z);
          } catch (e) { /* ignore if view not ready */ }

          this.mapCenter = [lat, lon];
          this.mapService.setCentroid(centroidParam);
        }
      }
    }
  }


  polygonWKTRemove(polygon: any) {
    const index = this.drawnPolygons.indexOf(polygon);
    if (index !== -1) {
      this.drawnPolygons.splice(index, 1);
    }
    this.releaseColor(polygon.id_);
    const all = this.drawSource.getFeatures();
    const newList = all.filter((f: any) => f.id_ !== polygon.id_);
    this.drawSource.clear();
    this.drawSource.addFeatures(newList);
    setTimeout(() => {
      this.fitPolygonOnMap();
    }, 200);
    if (this.drawnPolygons.length == 0) {
      this.drawSource.clear();
      this.polygon_create = false;
      this.polygon_WKT = '';
      this.router.navigate([], {
        queryParams: {
          'polygon': null,
          'youCanRemoveMultiple': null,
        },
        queryParamsHandling: 'merge'
      })
    } else {
      this.updateUrlPolygon();
    }
    if (this.drawnPolygons.length === 0) {
      this.sharedService.clearSession('filter');
    }
  }

  /**
   * Getting Unique Color using id
   */
  getUniqueColor(id: string, area: string) {
    if (this.availableColors.length === 0) {
      this.availableColors = [...this.colors];
      this.availableColorClasses = [...this.colorsClass];
    }

    const color = this.availableColors.shift()!;
    const className = this.availableColorClasses.shift()!;

    this.usedColors.push({ id, color, area, className, catchmentType: this.SelectedShap });
    return { color, className };
  }

  /**
   * Update selected Color list
   * @param id 
   * @returns 
   */
  releaseColor(id: string) {
    const index = this.usedColors.findIndex(x => x.id === id);
    if (index === -1) return;

    const used = this.usedColors[index];

    // put back colors to pool
    this.availableColors.push(used.color);
    this.availableColorClasses.push(used.className);

    // remove from used list
    this.usedColors.splice(index, 1);
  }

  private createCatchmentTooltip(type: string, drawerState:boolean=false) {
    let catchmenttootipText:any = {
      Polygon: {1:'Click and drag to draw Polygon', 2:'اضغط واسحب لرسم مضلع'},
      Rectangle: {1:'Click and drag to draw Rectangle', 2:'اضغط واسحب لرسم مستطيل'},
      Circle: {1:'Click and drag to draw Circle', 2: 'اضغط واسحب لرسم دائرة'},
      polygonDrawer: {1:'Double Click to close Polygon', 2: 'انقر مرتين لإغلاق المضلع'},
    }
    // Remove existing tooltip if any
    if (this.catchmentTooltipOverlay) {
      // this.map?.removeOverlay(this.catchmentTooltipOverlay);
      this.catchmentTooltipEl.innerText = (drawerState && type.toLocaleLowerCase() == 'polygon')?catchmenttootipText.polygonDrawer[this.current_lang_id] :catchmenttootipText[type][this.current_lang_id] ;
      return;
    }
    
    this.catchmentTooltipEl = document.createElement('div');
    this.catchmentTooltipEl.className = 'catchment-tooltip';
    this.catchmentTooltipEl.innerText = (drawerState && type.toLocaleLowerCase() == 'polygon')?catchmenttootipText.polygonDrawer[this.current_lang_id] :catchmenttootipText[type][this.current_lang_id] ;

    this.catchmentTooltipOverlay = new Overlay({
      element: this.catchmentTooltipEl,
      offset: [12, -12],
      positioning: 'top-left',
      stopEvent: false
    });

    this.map?.addOverlay(this.catchmentTooltipOverlay);
  }
  /**
   * Enable Drawing on click buttons
   * @param type 
   * @returns 
   */
  enableDrawing(type: string) {

  if (this.drawSource.getFeatures().length >= this.MAX_SHAPES) {
    this.alertService.warn("You can draw only 4 shapes");
    return;
  }

  this.cancelDrawing();
  this.isDrawingCatchment = true;
  this.SelectedShap = type;

  let drawOptions: any = {
    source: this.drawSource,
    freehand: false,
    style: (feature:Feature) => this.measureStyleFunction(feature)
  };

  if (type === "Circle" || type === "Rectangle") {
    drawOptions.freehand = true;
  }

  drawOptions.type = type;

  if (type === "Rectangle") {
    drawOptions.type = "Circle";
    drawOptions.geometryFunction = createBox();
  }

  this.draw = new Draw(drawOptions);
  this.map?.addInteraction(this.draw);
  this.viewport.classList.add("crosshair-pointer");

  let drawerState = false;

  this.draw.on("drawstart", (e: any) => {
    drawerState = true;
    if (type.toLowerCase() == "polygon") this.catchmentPolyGonDrawStart = true;
    this.createCatchmentTooltip(type, drawerState);
    const feature = e.feature;
    const id = "f_" + Date.now();
    feature.setId(id);

    feature.set("catchmentType", type);

  if (type.toLowerCase() === "polygon") {
        const geometry = feature.getGeometry();
        if (geometry instanceof Polygon) {
          geometry.on("change", () => {
            feature.set("catchmentType", type);
            feature.changed();
          });
        }
      }
  });

  this.draw.on("drawend", (e: any) => {
    this.reportService.detailPageState$.next(false);
    this.catchmentPolyGonDrawStart = false;
    drawerState = false;
    this.createCatchmentTooltip(type, drawerState);

    const feature = e.feature;
    const id = feature.getId();
    const geometry = feature.getGeometry();
    let CircleArea:any = null;
    let area = 0;

    if (geometry instanceof Circle) {
      // const radius = geometry.getRadius();
      // area = Math.PI * radius * radius;

      const circle = geometry as Circle;
      const radius = circle.getRadius();

      CircleArea = radius >= 1000
        ? (radius / 1000).toFixed(2) + ' km'
        : radius.toFixed(0) + ' m';
    }

    if (geometry instanceof Polygon) {
      area = getArea(geometry, { projection: "EPSG:3857" });
    }
    const areaKm = area / 1_000_000;

    const formattedArea = CircleArea ? CircleArea :
    areaKm >= 1 ? areaKm.toFixed(2) + " km²" : area.toFixed(0) + " m²";
    feature.set("area", formattedArea);
    const picked = this.getUniqueColor(id, formattedArea);
    feature.set("color_class_name", picked.className);
    feature.set("color", picked.color);
    feature.set("catchmentType", type);
    feature.changed();

    // Zoom to feature
    setTimeout(() => this.fitPolygonOnMap(), 200);
    setTimeout(() => this.updateUrlPolygon(), 500);

    // End draw
    this.cancelDrawing();
    this.SelectedShap = "";
  });
}

formatArea (polygon:any) {
  const area = getArea(polygon);
  let output;
  if (area > 10000) {
    output = Math.round((area / 1000000) * 100) / 100 + ' km\xB2';
  } else {
    output = Math.round(area * 100) / 100 + ' m\xB2';
  }
  return output;
};
formatLength(line: any) {
  const length = getLength(line);
  let output;
  if (length > 1000) {
    output = Math.round((length / 1000) * 100) / 100 + ' km';
  } else {
    output = Math.round(length * 10) / 10 + ' m';
  }
  return output;
};

  /**
   * Clear drawing
   */
  cancelDrawing() {
    this.isDrawingCatchment = false;
    if (this.draw) {
      this.map?.removeInteraction(this.draw);
      this.draw = null;
    }
    this.viewport.classList.remove('crosshair-pointer');
    if (this.catchmentTooltipOverlay) {
      this.map?.removeOverlay(this.catchmentTooltipOverlay);
      this.catchmentTooltipOverlay = null as any;
    }
  }

  /**
   * Get Geom from catchment
   * @returns 
   */
  getGeoJSON(): any {
    const geo = {
      type: 'FeatureCollection',
      features: this.drawSource.getFeatures().map(f => {
        let geomCircle: any =null;
        let geom: any = f.getGeometry();
        if (geom.getType() === 'Circle') {
          const circle = geom as Circle;
          const center3857 = circle.getCenter();
          const center4326 = transform(center3857, 'EPSG:3857', 'EPSG:4326');
          f.set('center', center4326);
          f.set('radius', circle.getRadius());
          geom = fromCircle(geom, 64);   
          geomCircle = f.getGeometry(); // store original circle geometry
        }
        const clonedGeom = geom.clone();
        clonedGeom.transform('EPSG:3857', 'EPSG:4326');
        return {
          type: 'Feature',
          id_: f.getId(),
          colorClassName: f.get('color_class_name'),
          color: f.get('color'),
          area: f.get('area'),
          catchmentType: f.get('catchmentType'),
          center: f.get('center'),
          radius: f.get('radius'),
          properties: {},
          geometry: this.geojson.writeGeometryObject(clonedGeom)
        };
      })
    };
    return geo;
  }

  
  /**
   * Update polygon on URL
   */
  updateUrlPolygon() {
    const geojsonData = this.getGeoJSON();
    this.drawnPolygons = geojsonData.features;
    this.polygon_WKT = JSON.stringify(geojsonData);
    this.router.navigate([], {
      queryParams: { polygon: this.polygon_WKT, zoom: this.mapZoom, centroid: this.mapService.getCentroid() },
      queryParamsHandling: 'merge',
    });
  }

  /**
   * Fit Bounce fit polygon on map view 
   * @returns 
   */
  fitPolygonOnMap() {
    const allFeatures: any = this.drawSource.getFeatures();
    if (allFeatures.length === 0) return;

    // Combine all extents
    let extent = allFeatures[0].getGeometry().getExtent().slice();

    allFeatures.forEach((f: any) => {
      olExtent.extend(extent, f.getGeometry().getExtent());
    });

    this.map?.getView().fit(extent, {
      padding: [50, 50, 50, 50],
      duration: 300,
      constrainResolution: false,
    });
  }



  OpenCustomPop(content: any, condinates: any[], class_name:string='', is_project_popup: boolean = false) {
    let position_class:Positioning =  (class_name == 'topCenter') ? 'top-center': 
    (class_name == 'bottomCenter') ? 'bottom-center' :
    (class_name == 'topLeft') ? 'top-left' :
    (class_name == 'topRight') ? 'top-right' :
    (class_name == 'bottomLeft') ? 'bottom-left' :
    (class_name == 'bottomRight') ? 'bottom-right' : 'bottom-center';
    let offset_xy: number[] = (class_name == 'topCenter') ? is_project_popup?[0, 18]: [0, 15] : 
    (class_name == 'bottomCenter') ?  [0, -15] :
    (class_name == 'topLeft') ? [15, -15] :
    (class_name == 'topRight') ? [-15, -15] :
    (class_name == 'bottomLeft') ? [15, 15] :
    (class_name == 'bottomRight') ? [-15, 15] : is_project_popup?[0, -20]: [0, -15];
    this.closePopup();
    this.popupOverlay = new Overlay({
      element: content,
      autoPan: false,
      offset: offset_xy,
      positioning: position_class,
      className: `custom-popup-design ${class_name || ''}`,
    })
    
    this.popupOverlay.setPosition(condinates);
    this.map?.addOverlay(this.popupOverlay);
  }

  addImageMarker(
    lat: number,
    lon: number,
    imageUrl: string,
    scale: number = 1,
    content: any = '',
    properties: any = null
  ) {
    if (!this.map) return;

    const coordinate = fromLonLat([lon, lat]);

    const marker = new Feature({
      geometry: new Point(coordinate)
    });

    marker.setProperties({
      type: 'marker',
      popupContent: content,
      properties: properties
    });

    marker.setStyle([
      new Style({
        image: new Icon({
          src: imageUrl,
          scale: scale,
          anchor: [0.5, 1],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          crossOrigin: 'anonymous'
        }),
        zIndex: 9999
      })
    ]);

    this.markerSource.addFeature(marker);

    return marker;
  }


  removeOLMarker(marker: Feature) {
    this.markerSource.removeFeature(marker);
  }

  
  ngOnDestroy(): void {
     if (this.map) {
        this.map.setTarget(null);
        this.map = null;
      }
    if (this.count_LayerSub$) this.count_LayerSub$.unsubscribe();
    if (this.overlay_LayerSub2$) this.overlay_LayerSub2$.unsubscribe();
    this.removeScrollPropagationEvent();
    this.moveEndSubscriptionMap$?.unsubscribe();
    this.mapService.tenantName.set('');
    this.selectedReportSubscription$?.unsubscribe();
    this.moveEndSubscription1$?.unsubscribe();
    this.moveEndSubscription2$?.unsubscribe();
    this.moveEndSubscription3$?.unsubscribe();
    this.moveEndSubscription4$?.unsubscribe();
    this.resetFilterSub$.unsubscribe();
    this.selectedReportSub$?.unsubscribe();
    this.drawPolySub$?.unsubscribe();
   
     if (this.zoomListener) {
        unByKey(this.zoomListener);
      }

      if (this.moveEndListener) {
        unByKey(this.moveEndListener);
      }

    this.overlay_LayerSub$?.unsubscribe();
    this.mapCoordinatesSub$?.unsubscribe();
    this.routeSub$.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.NeighDetails$.unsubscribe();
    if (this.drawControl) {
      this.drawControl.remove()
    }
  }
}